import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Accordion, Button, Col, Dropdown, DropdownButton, FormControl, Modal, Row, Table } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Image from 'react-bootstrap/Image';
import PageShell from './ui/PageShell';
import ActionIcon from './ui/ActionIcon';
import API_BASE_URL, { api } from '../config/api';
import {
  canAssignRequirement,
  canClaimRequirement,
  canEditRequirement,
  canUnclaimRequirement,
  canUploadToRequirement,
  getAssignDisabledMessage,
  getTlRequirementPrimaryActionButtonColor,
  getTlRequirementPrimaryActionDisplay,
  getUploadDisabledMessage,
} from '../utils/requirementWorkflow';
import { deleteRequirement, unclaimRequirement as unclaimRequirementApi, updateAssignedUserUploadStatus } from '../services/requirementService';
import RequirementRecruitersModal from './requirements/RequirementRecruitersModal';
import RequirementClaimsModal from './requirements/RequirementClaimsModal';
import RequirementRejectedModal from './requirements/RequirementRejectedModal';
import RequirementCandidatesModal from './requirements/RequirementCandidatesModal';
import { getRejectedCandidates } from '../services/candidateService';
import RequirementEditModal from './requirements/RequirementEditModal';
import {
  getUploadDisplayState,
  UploadStatusBadge,
  UploadActionButton,
} from './requirements/assignedUserUploadUi';
import RequirementJdActions from './requirements/RequirementJdActions';
import { useLayout, CANDIDATE_ACTIVITY_REFRESH_KEYS } from '../layout/AppLayout';
import { getDecryptedData } from '../utils/authStorage';
import {
  statusRequiresInterviewDate,
  getPersistedCandidateStatus,
  getRecentCandidateStatus,
  canEditFullSourceProfileDetails,
  countActionTakenCandidates,
  countRejectedCandidates,
  filterActiveCandidates,
  filterNoActionTakenCandidates,
} from '../utils/candidateStatus';
import SourceProfileDocumentFields from './ui/SourceProfileDocumentFields';
import { buildApiAssetUrl } from '../utils/apiAssetUrl';
import StatusBadge from './ui/StatusBadge';
import { matchesUploadedDateRange, getDefaultRequirementListMonthRange } from '../utils/requirementDateFilter';
import {
  sortByPriorityThenUploadedDate,
  sortByRequirementTypeThenPriority,
} from '../utils/requirementPriority';
import PriorityBadge from './ui/PriorityBadge';
import TLRequirementFilterBar from './ui/TLRequirementFilterBar';
import StatusUpdatePanel from './ui/StatusUpdatePanel';
import StatusHistorySection from './ui/StatusHistorySection';
import { mergeCandidateStatusRemarkUpdate } from '../utils/statusRemarks';
import {
  formatDisplayDate,
  formatInterviewDate,
  formatLwdDisplay,
  normalizeLwdForInput,
  toDateInputValue,
} from '../utils/dateFormat';
import RequirementTypeSelect from './ui/RequirementTypeSelect';
import {
  matchesRequirementTypeFilter,
  REQUIREMENT_TYPE_OPTIONS,
} from '../utils/requirementType';
import {
  getRequirementSourceBadgeClass,
  getRequirementSourceFromRow,
} from '../utils/requirementSource';
import { submitStatusUpdate } from '../utils/submitStatusUpdate';
import {
  applyCandidateStatusUpdate,
  fetchRequirementRecruiters,
  normalizeCandidateList,
  normalizeCandidateRecord,
  normalizeRecruiterCandidateGroups,
  normalizeTlRequirementAssignment,
} from '../utils/candidateListState';
import { showSuccess, showError, showWarning, showInfo } from '../utils/toast';
import { getApiErrorMessage } from '../utils/apiError';
import { getTodayMonitor } from '../services/workflowService';
import {
  MONITOR_FILTER_LABELS,
  scopeTlRequirementRowForMonitor,
} from '../utils/todayMonitor';

const DEFAULT_TL_DATE_RANGE = getDefaultRequirementListMonthRange();

function TLHome({ view = 'requirements' }) {
  const userId = getDecryptedData("Id");
  const [searchParams, setSearchParams] = useSearchParams();
  const focusedRequirementId = searchParams.get('requirementId') || '';
  const focusedProfileId = searchParams.get('profileId') || '';
  const monitorKey = MONITOR_FILTER_LABELS[searchParams.get('monitor')]
    ? searchParams.get('monitor')
    : '';
  const [monitorBucket, setMonitorBucket] = useState(null);
  const [monitorFilterLoading, setMonitorFilterLoading] = useState(false);
  const profileDeepLinkRef = useRef('');
  const profileModalDeepLinkRef = useRef('');
  const [highlightProfileId, setHighlightProfileId] = useState('');
  const isRequirementsListView = view === 'requirements' || view === 'all-requirements';
  const requirementListScope = view === 'requirements' ? 'mine' : 'all';
  let [showUserData,setShowUserData]= useState([]);
  const [show, setShow] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const [showfl, setShowfl] = useState(false);
  const [showprofiles, setShowprofiles] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [showTodayData,setShowTodayData]= useState(false);
  const [requirements,setRequirements] = useState([]);
  const [assignedUsersData,setAssignedUsersData] = useState([]);
  const [selectedReqId,setSelectedReqId]= useState('');
  const [selectedRecruiterId,setSelectedRecruiterId]= useState('');
  const [searchTerm, setSearchTerm] = useState("");       // Store the search input
  const [submissionPanel, setSubmissionPanel] = useState('');
  const [submissionSearch, setSubmissionSearch] = useState('');
  const [submissionRecruiterDetail, setSubmissionRecruiterDetail] = useState(null);
  const [filteredRequirements, setFilteredRequirements] = useState([]); // Store filtered requirements
  const [totalCount,setTotalCount] = useState(0);
  const [todayCount,setTodayCount] = useState(0);
  const [showtodayCandidates,setshowtodayCandidates]= useState(false);
  const [showtotalCandidates,setshowtotalCandidates] = useState(false);
  const [showCandidateDetailsHome,setShowCandidateDetailsHome]= useState([]);
  const [showRequirmentCount,setShowRequirmentCount]= useState(false);
  const [showUserModal,setShowUserModal] = useState(false);
  const [claimedByCounts, setClaimedByCounts] = useState({});
  const [showClaimedUsers, setShowClaimedUsers] = useState([]);
  const [showClaimsModal, setShowClaimsModal] = useState(false);
  const [claimsModalMeta, setClaimsModalMeta] = useState({ regId: '' });
  const [showProfilesModal, setShowProfilesModal] = useState(false);
  const [profilesModalMeta, setProfilesModalMeta] = useState({
    regId: '',
    mode: 'all',
    requirementId: '',
    scopedCandidates: null,
  });
  const profilesReloadRequestRef = useRef(0);

  const reloadOpenProfilesModal = useCallback(async (requirementId) => {
    const reqId = requirementId || profilesModalMeta.requirementId;
    if (!reqId) return [];

    const requestId = profilesReloadRequestRef.current + 1;
    profilesReloadRequestRef.current = requestId;

    try {
      const recruiters = await fetchRequirementRecruiters(api, reqId);
      if (profilesReloadRequestRef.current !== requestId) return recruiters;
      setRecruitersData(recruiters);
      return recruiters;
    } catch (error) {
      const message = error.message || '';
      if (profilesReloadRequestRef.current === requestId && /not found|no recruiters/i.test(message)) {
        setRecruitersData([]);
      }
      return [];
    }
  }, [profilesModalMeta.requirementId]);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [rejectedModalMeta, setRejectedModalMeta] = useState({ regId: '', requirementId: '' });
  const [rejectedRows, setRejectedRows] = useState([]);
  const [rejectedLoading, setRejectedLoading] = useState(false);
  const [recruitersData, setRecruitersData] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [openItems, setOpenItems] = useState({});
  const [candidatesListModal, setCandidatesListModal] = useState({
    show: false,
    title: '',
    subtitle: '',
    candidates: [],
    statusFilter: '',
  });
  const [currentRecruiter,setCurrentRecruiter] = useState([]);
  const [recruiterStats, setRecruiterStats] = useState([]);
  const [assignReqdetails,setAssignReqdetails]=useState([]);
  const [candidates, setCandidates] = useState([]);
  const [requirementsData, setRequirementsData] = useState([]); // State for requirements
  const [loading, setLoading] = useState(true); // State for loading status
  const [, setError] = useState(null); // State for error
  const [candidateDetails,setCandidateDetails] = useState([]);
  const [lagShow, setLagShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [candidateId,setCandidateId]=useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [statusInterviewDate, setStatusInterviewDate] = useState('');
  const [statusRemark, setStatusRemark] = useState('');
  const [uploadedFromDate, setUploadedFromDate] = useState(DEFAULT_TL_DATE_RANGE.from);
  const [uploadedToDate, setUploadedToDate] = useState(DEFAULT_TL_DATE_RANGE.to);
  const requirementTypes = REQUIREMENT_TYPE_OPTIONS;
  const [selectedTypes, setSelectedTypes] = useState(['High', 'Medium']);
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [status, setStatus] = useState('');
const [savedStatus,setSavedStatus] = useState('');
const [displayedCandidates, setDisplayedCandidates] = useState([]);
const [userUploadsModalMeta, setUserUploadsModalMeta] = useState({ regId: '', requirementId: '' });
const [updateshow, setUpdateshow] = useState(false);
const [, setNewRequirements] = useState([]);

const handleRequirementTypeUpdated = (reqId, nextType, updatedRequirement) => {
  const patchUploadedDate = updatedRequirement?.uploadedDate != null
    ? { uploadedDate: updatedRequirement.uploadedDate }
    : {};

  const patchItem = (item) => {
    if (!item) return item;
    if (item._id === reqId) {
      return { ...item, requirementtype: nextType, ...patchUploadedDate };
    }
    if (item.requirement?._id === reqId) {
      return {
        ...item,
        requirement: { ...item.requirement, requirementtype: nextType, ...patchUploadedDate },
      };
    }
    if (item.requirementDetails?._id === reqId) {
      return {
        ...item,
        requirementDetails: {
          ...item.requirementDetails,
          requirementtype: nextType,
          ...patchUploadedDate,
        },
      };
    }
    return item;
  };

  setRequirements((prev) => prev.map(patchItem));
  setFilteredRequirements((prev) => prev.map(patchItem));
  setShowCandidateDetailsHome((prev) => prev.map(patchItem));
  setRequirementsData((prev) => prev.map(patchItem));
  setNewRequirements((prev) => prev.map(patchItem));
};


const [updateCandidateDetails, setUpdateCandidateDetails] = useState({
  candidateImage: '',
  firstName: '',
  lastName: '',
  email: '',
  mobileNumber: '',
  dob: '',
  ctc: '',
  ectc: '',
  totalYoe: '',
  relevantYoe: '',
  lwd: '',
  currentLocation: '',
  prefLocation: '',
  resignationServed: '',
  currentOrg: '',
  candidateSkills: '',
  role: '',
  internalScreening: '',
  sharedWithClient: '',
  feedback: '',
  details: '',
  interviewDate: '',
  interviewTime: '',
  educationalQualification: '',
  offerInHand: '',
  remark: '',
  updatedResume: '',
  ornnovaProfile: '',
  assessments: [],
});

function handleUpdateShow() {
    
  setUpdateshow(true);
}
function handleUpdateClose () {setUpdateshow(false);}

// Function to delete a candidate
const deleteCandidate = async (candidateId) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this candidate?");
  if (!isConfirmed) {
    return; // Exit the function if the user cancels
  }

  try {
    const response = await api.delete(`/api/candidates/${candidateId}`);
    if (response.status === 200) {
      setCandidates(candidates.filter(candidate => candidate._id !== candidateId));
      setSelectedCandidates((prev) => prev.filter((candidate) => candidate._id !== candidateId));
      triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
      showSuccess(response.data.message || 'Candidate deleted successfully ✓');
    }
  } catch (error) {
    console.error("Error deleting candidate:", error);
    showError(getApiErrorMessage(error, 'Failed to delete candidate. Please try again.'));
  }
};

const updateCandidate = async(id)=>{
  try {
    const response = await api.get(`/candidate/${id}`)
    console.log(response.data)
    setUpdateCandidateDetails({
      ...response.data,
      lwd: normalizeLwdForInput(response.data?.lwd),
    });
    handleUpdateShow();
  } catch (error) {
    console.log(error)
  }
}

const handleInputChange = (field, value) => {
  setUpdateCandidateDetails(prevDetails => ({
    ...prevDetails,
    [field]: value,
  }));
};

const handleAssessmentChange = (index, field, value) => {
  const updatedAssessments = [...updateCandidateDetails.assessments];
  updatedAssessments[index] = {
    ...updatedAssessments[index],
    [field]: value,
  };
  setUpdateCandidateDetails(prevDetails => ({
    ...prevDetails,
    assessments: updatedAssessments,
  }));
};

// Function that saves changes, with conditional logic for "Upload"
const handleSaveChanges = async (status) => {
const candidateId = updateCandidateDetails._id;

try {
  // Prepare updated details based on whether it's a save or upload action
  const updatedDetails = {
    ...updateCandidateDetails,
    lwd: String(updateCandidateDetails.lwd || '').trim(),
    ...(status === "Uploaded" ? { savedStatus: "Uploaded", uploadedDate: new Date().toISOString() } : {})
  };

  const response = await api.put(`/candidates/${candidateId}`, updatedDetails);

  if (response.status === 200) {
    showSuccess('Candidate details updated successfully ✓');
    setUpdateshow(false);
    await requirementDetailsWithAssignedUsers();
    if (candidateId) {
      await CandidateData(candidateId);
    }
  } else {
    showError('Failed to update candidate details. Please try again.');
  }
} catch (error) {
  console.error('Error updating candidate:', error);
  showError(getApiErrorMessage(error, 'An error occurred while updating candidate details.'));
}
};

// Separate functions for Save and Upload buttons
const saveChanges = () => handleSaveChanges("Saved");
const uploadChanges = () => handleSaveChanges("Uploaded");


  // Status options array
  const statusSearchOptions = [
    'Ornnova Screen Selected', 'Shared with Client', 'Client Rejected', 'L1 Schedule', 
    'L1 Selected', 'L1 Rejected', 'L2 Schedule', 'L2 Selected', 'L2 Rejected', 
    'Onboard Confirmation', 'On Boarded', 'Rejected', 'Declined'
  ];

  useEffect(() => {
    setDisplayedCandidates(selectedCandidates);
  }, [selectedCandidates]);

  useEffect(() => {
    if (!showUserModal || !userUploadsModalMeta.requirementId) return;

    const row = showCandidateDetailsHome.find(
      (req) => String(req.requirementDetails?._id) === String(userUploadsModalMeta.requirementId),
    );
    if (Array.isArray(row?.userActiveCandidatesDetails)) {
      setSelectedCandidates(normalizeCandidateList(row.userActiveCandidatesDetails));
    }
  }, [showCandidateDetailsHome, showUserModal, userUploadsModalMeta.requirementId]);
    const filteredData = useMemo(() => {
      const filtered = (Array.isArray(showCandidateDetailsHome) ? showCandidateDetailsHome : []).filter((req) => {
        const details = req?.requirementDetails;
        if (!details) return false;

        if (monitorKey) {
          const allowedIds = new Set((monitorBucket?.requirementIds || []).map(String));
          if (!allowedIds.has(String(details._id))) return false;
        } else {
          const matchesType = selectedTypes.length === requirementTypes.length
            || matchesRequirementTypeFilter(details.requirementtype, selectedTypes);
          if (!matchesType) return false;
          if (!matchesUploadedDateRange(details.uploadedDate, uploadedFromDate, uploadedToDate)) {
            return false;
          }
        }

        const { regId = '', client = '', role = '' } = details;
        const query = searchQuery.toLowerCase();
        return (
          String(regId).toLowerCase().includes(query)
          || String(client).toLowerCase().includes(query)
          || String(role).toLowerCase().includes(query)
        );
      }).map((req) => {
        if (!monitorKey || !monitorBucket) return req;
        const reqId = String(req.requirementDetails?._id || '');
        const candidateIds = monitorBucket.candidatesByRequirement?.[reqId] || [];
        return scopeTlRequirementRowForMonitor(req, candidateIds);
      });

      return sortByRequirementTypeThenPriority(
        filtered,
        (req) => req?.requirementDetails?.requirementtype,
        (req) => req?.requirementDetails?.priority,
        (req) => req?.requirementDetails?.uploadedDate,
      );
    }, [
      showCandidateDetailsHome,
      searchQuery,
      uploadedFromDate,
      uploadedToDate,
      selectedTypes,
      requirementTypes.length,
      monitorKey,
      monitorBucket,
    ]);

  const sortedAssignRequirements = useMemo(
    () => sortByPriorityThenUploadedDate(
      filteredRequirements,
      (item) => item?.requirement?.priority,
      (item) => item?.requirement?.uploadedDate,
    ),
    [filteredRequirements]
  );

  const handleClearRequirementFilters = () => {
    const defaultRange = getDefaultRequirementListMonthRange();
    setSearchQuery('');
    setUploadedFromDate(defaultRange.from);
    setUploadedToDate(defaultRange.to);
  };

  const handleTypeCheckboxChange = (type) => {
    if (type === 'all') {
      setSelectedTypes(selectedTypes.length === requirementTypes.length ? [] : requirementTypes);
      return;
    }
    setSelectedTypes((prevSelected) => (
      prevSelected.includes(type)
        ? prevSelected.filter((item) => item !== type)
        : [...prevSelected, type]
    ));
  };

  const getTypeFilterTitle = () => {
    if (selectedTypes.length === requirementTypes.length) return 'All';
    if (selectedTypes.length === 0) return 'Select';
    return selectedTypes.join(', ');
  };

  const handleDeleteRequirement = async (requirementId, regIdLabel = '') => {
    if (!requirementId) return;

    const label = regIdLabel ? ` ${regIdLabel}` : '';
    const isConfirmed = window.confirm(
      `Are you sure you want to delete requirement${label}? This will remove the requirement and its associated source profiles.`,
    );
    if (!isConfirmed) return;

    try {
      await deleteRequirement(requirementId);
      showSuccess('Requirement deleted successfully ✓');
      if (expandedId === requirementId) {
        setExpandedId(null);
      }
      triggerTableRefresh('requirements');
    } catch (error) {
      showError(getApiErrorMessage(error, 'Failed to delete requirement. Please try again.'));
      console.error('Error deleting requirement:', error);
    }
  };

  const handleUserCandidatesSearch = () => {
    const filteredUserCandidates = selectedCandidates.filter(candidate => {
      const nameMatches = `${candidate.firstName} ${candidate.lastName}`.toLowerCase().includes(name.toLowerCase());
      const roleMatches = candidate.role.toLowerCase().includes(role.toLowerCase());
      const statusMatches = status
        ? getRecentCandidateStatus(candidate).toLowerCase().includes(status.toLowerCase())
        : true;
  
      // Check for savedStatus match if it's selected
      const savedStatusMatches = savedStatus
        ? candidate.savedStatus && candidate.savedStatus.toLowerCase() === savedStatus.toLowerCase()
        : true; // if no savedStatus selected, include all
  
      return nameMatches && roleMatches && statusMatches && savedStatusMatches;
    });
  
    setDisplayedCandidates(filteredUserCandidates);
  };

  const openCandidatesListModal = ({ title, subtitle, candidates, statusFilter = '' }) => {
    setCandidatesListModal({
      show: true,
      title,
      subtitle,
      candidates: normalizeCandidateList(candidates || []),
      statusFilter,
    });
  };

  const closeCandidatesListModal = () => {
    setCandidatesListModal({
      show: false,
      title: '',
      subtitle: '',
      candidates: [],
      statusFilter: '',
    });
  };

  const handleShowCandidates = (candidates, regId) => {
    openCandidatesListModal({
      title: 'Uploaded Today',
      subtitle: regId ? `Req ID: ${regId}` : '',
      candidates,
    });
  };

  const handleShowTeamCandidates = (teamCandidatesDetails, regId) => {
    openCandidatesListModal({
      title: 'Team Uploads',
      subtitle: regId ? `Req ID: ${regId}` : '',
      candidates: teamCandidatesDetails,
    });
  };

  const refreshUserUploadsCandidates = useCallback(async (requirementId, fallbackCandidates = []) => {
    const fallback = filterActiveCandidates(normalizeCandidateList(fallbackCandidates));

    if (!requirementId || !userId) {
      setSelectedCandidates(fallback);
      return fallback;
    }

    try {
      const { data } = await api.get(`/viewactions/${requirementId}/${userId}`);
      const refreshed = filterActiveCandidates(
        normalizeCandidateList(data.uploadedCandidates || []),
      );
      setSelectedCandidates(refreshed);
      return refreshed;
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('Error refreshing user uploads:', error);
      }
      setSelectedCandidates(fallback);
      return fallback;
    }
  }, [userId]);

  const handleShowUserCandidates = async (userCandidates, regId, requirementId) => {
    setUserUploadsModalMeta({ regId: regId || '', requirementId: requirementId || '' });
    setName('');
    setRole('');
    setStatus('');
    setSavedStatus('');
    setShowUserModal(true);
    await refreshUserUploadsCandidates(requirementId, userCandidates);
  };

  const handleCloseUserModal = () => {
    setShowUserModal(false);
    setUserUploadsModalMeta({ regId: '', requirementId: '' });
  };

  const { openFormModal, tableRefresh, triggerTableRefresh } = useLayout();

  const toggleFlip = (id) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const toggleAccordion = async (id) => {
    if (expandedId === id) {
      setExpandedId(null);
      return;
    }

    try {
      setRecruitersData([]);
      const recruiters = await fetchRequirementRecruiters(api, id);
      setRecruitersData(normalizeRecruiterCandidateGroups(recruiters));
      toggleFlip(id);
      setExpandedId(id);
    } catch (error) {
      const status = error.response?.status;
      const message = error.message || '';
      if (status === 404 || /not found|no recruiters/i.test(message)) {
        setRecruitersData([]);
        toggleFlip(id);
        setExpandedId(id);
        return;
      }
      console.error('Error loading recruiters:', error);
      showError(error.message || 'Unable to load recruiter details for this requirement.');
    }
  };

  useEffect(() => {
    if (!expandedId) return undefined;

    let cancelled = false;
    const reloadExpandedProfiles = async () => {
      try {
        const recruiters = await fetchRequirementRecruiters(api, expandedId);
        if (!cancelled) {
          setRecruitersData(normalizeRecruiterCandidateGroups(recruiters));
        }
      } catch (error) {
        const status = error.response?.status;
        const message = error.message || '';
        if (!cancelled && (status === 404 || /not found|no recruiters/i.test(message))) {
          setRecruitersData([]);
        }
      }
    };

    reloadExpandedProfiles();
    return () => {
      cancelled = true;
    };
  }, [expandedId, tableRefresh.candidates, tableRefresh.requirements]);

  // State to store user and team data
  const [userData, setUserData] = useState(null);
  const [teamData, setTeamData] = useState([]);

  // Fetch user and team data
  const fetchUserData = async (userId) => {
    try {
      const { data } = await api.get(`/TlHome/${userId}`);
      setUserData(data.user);
      setTeamData(Array.isArray(data.Team) ? data.Team : []);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserData(userId);
    }
  }, [userId]);

  let readUserDatafun = async (id) => {
    try {
        const { data: JSOData } = await api.get(`/getUserData/${id}`);

        // Extract user details and team details from the response
        const { userDetails, teamDetails } = JSOData;

        // You can now use userDetails and teamDetails as needed
        setShowUserData({ userDetails, teamDetails });

        // Show the data, possibly in a modal or some other component
        handleShow();
    } catch (error) {
        console.error("Error fetching user data:", error);
    }
};

 // Fetch requirements from the API
 const loadAssignRequirements = useCallback(async (openModal = false) => {
  try {
    const { data: JSOData } = await api.get(`/getTeamrequirements/${userId}`);
    setRequirements(JSOData);
    setFilteredRequirements(JSOData);
    if (openModal) setShowfl(true);
  } catch (error) {
    console.log(error);
  }
}, [userId]);

// Handle search input change
const handleSearchChange = (e) => {
  const term = e.target.value;
  setSearchTerm(term);

  // Filter requirements based on client name, handle undefined or null client values
  const filteredData = requirements.filter((item) =>
    (item.client || '').toLowerCase().includes(term.toLowerCase()) // Convert undefined to empty string before filtering
  );

  setFilteredRequirements(filteredData);  // Update filtered requirements
  
};

const filteredRecruiters = Array.isArray(recruiterStats) 
  ? recruiterStats.filter(recruiter => 
      recruiter.recruiterName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      recruiter.recruiterEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
      recruiter.recruiterCode.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

const openSubmissionPanel = (panel) => {
  setSubmissionPanel((prev) => {
    const next = prev === panel ? '' : panel;
    if (next !== 'recruiters') setSubmissionRecruiterDetail(null);
    return next;
  });
  setSubmissionSearch('');
};

const filteredSubmissionRecruiters = useMemo(() => {
  if (!Array.isArray(recruiterStats)) return [];
  const q = submissionSearch.toLowerCase();
  return recruiterStats.filter((recruiter) =>
    !q ||
    (recruiter.recruiterName || '').toLowerCase().includes(q) ||
    (recruiter.recruiterEmail || '').toLowerCase().includes(q) ||
    (recruiter.recruiterCode || '').toLowerCase().includes(q)
  );
}, [recruiterStats, submissionSearch]);

const todayCandidatesAll = useMemo(() => {
  if (!Array.isArray(recruiterStats)) return [];
  return recruiterStats.flatMap((r) =>
    (r.todaysCandidatesData || []).map((c) => ({
      ...c,
      recruiterName: r.recruiterName,
      recruiterCode: r.recruiterCode,
    }))
  );
}, [recruiterStats]);

const totalCandidatesAll = useMemo(() => {
  if (!Array.isArray(recruiterStats)) return [];
  return recruiterStats.flatMap((r) =>
    (r.totalCandidatesData || []).map((c) => ({
      ...c,
      recruiterName: r.recruiterName,
      recruiterCode: r.recruiterCode,
    }))
  );
}, [recruiterStats]);

const filteredTodayCandidates = useMemo(() => {
  const q = submissionSearch.toLowerCase();
  if (!q) return todayCandidatesAll;
  return todayCandidatesAll.filter((c) => {
    const name = `${c.firstName || ''} ${c.lastName || ''}`.toLowerCase();
    const skills = (c.candidateSkills || '').toLowerCase();
    const recruiter = (c.recruiterName || '').toLowerCase();
    return name.includes(q) || skills.includes(q) || recruiter.includes(q);
  });
}, [todayCandidatesAll, submissionSearch]);

const filteredTotalCandidates = useMemo(() => {
  const q = submissionSearch.toLowerCase();
  if (!q) return totalCandidatesAll;
  return totalCandidatesAll.filter((c) => {
    const name = `${c.firstName || ''} ${c.lastName || ''}`.toLowerCase();
    const skills = (c.candidateSkills || '').toLowerCase();
    const recruiter = (c.recruiterName || '').toLowerCase();
    return name.includes(q) || skills.includes(q) || recruiter.includes(q);
  });
}, [totalCandidatesAll, submissionSearch]);

const [viewReq, setViewReq] = useState([]);
  const [showReq, setShowReq] = useState(false);
  const [showEditReq, setShowEditReq] = useState(false);

const viewRequirement = async (id) => {
    try {
      const { data: JSOData } = await api.get(`/getrequirements/${id}`);
      
      setViewReq([JSOData]);
      setShowReq(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

const refreshViewRequirement = async (id) => {
  if (!id) return;
  try {
    const { data } = await api.get(`/getrequirements/${id}`);
    setViewReq([data]);
  } catch (error) {
    console.error('Error refreshing requirement details:', error);
  }
};

const handleRequirementEdited = async (updated) => {
  const reqId = updated?._id || viewReq[0]?._id;
  if (reqId) {
    await refreshViewRequirement(reqId);
    handleRequirementTypeUpdated(reqId, updated?.requirementtype, updated);
    await requirementDetailsWithAssignedUsers();
  }
};

  const userDetailsofAssignedClient = async (id) => {
    const { data } = await api.get(`/userDetailsofAssignedRequirement/${id}/${userId}`);
    setAssignedUsersData(data);
    console.log(data)
};
  const userDetailstoAssignClient = async (id) => {
    const { data } = await api.get(`/userDetailstoAssignRequirement/${id}/${userId}`);
    console.log(data)
    setUserData(data.teamMembers);
    if (Array.isArray(data.requirementDetails)) {
      setAssignReqdetails(data.requirementDetails);
    } else if (data.requirementDetails && typeof data.requirementDetails === "object") {
      setAssignReqdetails([data.requirementDetails]);
    } else {
      setAssignReqdetails([]);
    }
     setSelectedReqId(id);
    userDetailsofAssignedClient(id);
    setShowAssign(true)
};

const handleOpenAssignModal = async (requirementId, requirementDetails = null) => {
  if (requirementDetails?.workflow && !canAssignRequirement(requirementDetails)) {
    showWarning(getAssignDisabledMessage(requirementDetails));
    return;
  }
  await userDetailstoAssignClient(requirementId);
};

const assignReqToUser = async (userId) => {
  const ReqId = selectedReqId; // Ensure you have a way to store the selected client ID

  // Show a confirmation dialog to the user
  const isConfirmed = window.confirm(`Are you sure you want to assign this Requirement ?`);

  // If the user confirms, proceed with the assignment
  if (isConfirmed) {
      try {
          const response = await api.post(`/assignReq/${userId}/${ReqId}`);

          const result = response.data;

          if (result.status === 'success') {
              showSuccess('Requirement assigned successfully ✓');
              setShowAssign(false);
              await userDetailstoAssignClient(ReqId);
              await requirementDetailsWithAssignedUsers();
              if (view === 'assign') await loadAssignRequirements(false);
          } else {
              showError(result.msg || 'Failed to assign requirement. Please try again.');
          }
      } catch (error) {
          console.error('Error assigning client:', error.response ? error.response.data : error.message);
          showError(getApiErrorMessage(error, 'An error occurred while assigning the requirement. Please try again later.'));
      }
  } else {
      showInfo('Requirement assignment was canceled.');
  }
};

const unassignReqFromUser = async (userId) => {
  const ReqId = selectedReqId; // Ensure you have a way to store the selected requirement ID

  // Show a confirmation dialog to the user
  const isConfirmed = window.confirm(`Are you sure you want to unassign this Requirement?`);

  // If the user confirms, proceed with the unassignment
  if (isConfirmed) {
      try {
          const response = await api.post(`/unassignReq/${userId}/${ReqId}`);

          const result = response.data;

          if (result.status === 'success') {
              showSuccess('Requirement unassigned successfully ✓');
              setShowAssign(false);
              await userDetailstoAssignClient(ReqId);
              await requirementDetailsWithAssignedUsers();
              if (view === 'assign') await loadAssignRequirements(false);
          } else {
              showError(result.msg || 'Failed to unassign requirement. Please try again.');
          }
      } catch (error) {
          console.error('Error unassigning requirement:', error.response ? error.response.data : error.message);
          showError(getApiErrorMessage(error, 'An error occurred while unassigning the requirement. Please try again later.'));
      }
  } else {
      showInfo('Requirement unassignment was canceled.');
  }
};

const toggleAssignedUserUploadStatus = async (userId, isManuallyActive) => {
  const ReqId = selectedReqId;
  const nextManualState = !isManuallyActive;
  const isConfirmed = window.confirm(
    isManuallyActive
      ? 'Stop profile uploading for this user for this requirement?'
      : 'Start profile uploading for this user for this requirement?',
  );

  if (!isConfirmed) return;

  try {
    const result = await updateAssignedUserUploadStatus(ReqId, userId, nextManualState);

    if (result.status === 'Success') {
      showSuccess(isManuallyActive ? 'Profile upload stopped for this user.' : 'Profile upload started for this user.');
      await userDetailsofAssignedClient(ReqId);
    } else {
      showError(result.msg || 'Unable to update profile upload status.');
    }
  } catch (error) {
    console.error('Error updating profile upload status:', error);
    showError(getApiErrorMessage(error, 'Unable to update profile upload status.'));
  }
};

const loadProfileStats = useCallback(async (openModal = false) => {
  try {
    const { data } = await api.get(`/getTeamRequirementsCount/${userId}`);

    setTotalCount(data.totalCandidates);
    setTodayCount(data.todaysCandidates);
    setRecruiterStats(data.recruiterStats);

    if (openModal) setShowprofiles(true);
  } catch (error) {
    console.log('Error fetching team requirements:', error);
  }
}, [userId]);

const RequirmentCandidates = async (id) => {
  try {
    const { data } = await api.get(`/getRequirementsCandidatesCount/${id}/${userId}`);
    console.log(data)
    // Check if the response status is Success
    if (data.status === "Success" && data.requirements) {
      // Update the state with the fetched requirements
      setRequirementsData(data.requirements); // Store requirements in state
      setShowRequirmentCount(true);
      setSelectedRecruiterId(id);
    } else {
      // Handle unexpected data format or error messages
      throw new Error(data.msg || "Unexpected data format");
    }
  } catch (error) {
    // Handle any errors that occurred during the fetch
    console.error("Failed to fetch requirement candidates:", error);
    showError(getApiErrorMessage(error, 'Failed to load requirement candidates.'));
  }
};

const fetchCandidates = async (id) => {
  setLoading(true); // Show loading indicator
  setError(""); // Reset error state

  try {
    const { data } = await api.get(`/viewactions/${id}/${selectedRecruiterId}`);
  
    if (data.candidates) {
      setCandidates(normalizeCandidateList(data.uploadedCandidates));
      setshowtotalCandidates(true)
    } else {
      setError(data.message);
    }
  } catch (error) {
    setError(error.message || "Failed to fetch candidates");
  } finally {
    setLoading(false); // Hide loading indicator
  }
};

const CandidateData = async(id)=>{
  try {
      const response = await api.get(`/candidate/${id}`);
     
      // console.log(response.data)
          setCandidateDetails(normalizeCandidateRecord(response.data)); 
           setCandidateId(id);
           setSelectedStatus('');
           setStatusInterviewDate(toDateInputValue(response.data?.interviewDate));
      setLagShow(true)
  } catch (error) {
      console.error('Error fetching candidates:', error);
  } 
}



const requirementDetailsWithAssignedUsers = useCallback(async () => {
  try {
    const response = await api.get(`/requirementDetailsWithAssignedUsers/${userId}`, {
      params: { scope: requirementListScope },
    });
    const rows = Array.isArray(response.data) ? response.data : [];
    setShowCandidateDetailsHome(rows.map(normalizeTlRequirementAssignment));
  } catch (error) {
    console.error('Error loading TL requirements:', error);
    setShowCandidateDetailsHome([]);
  }
}, [userId, requirementListScope]);

useEffect(() => {
  if (!monitorKey || !userId) {
    setMonitorBucket(null);
    setMonitorFilterLoading(false);
    return undefined;
  }

  let cancelled = false;
  setMonitorFilterLoading(true);

  const loadMonitorFilter = async () => {
    try {
      const data = await getTodayMonitor(userId);
      if (cancelled) return;
      setMonitorBucket(data.filterBuckets?.[monitorKey] || {
        requirementIds: [],
        candidatesByRequirement: {},
      });
    } catch (error) {
      if (cancelled) return;
      console.error('Error loading today monitor filter:', error);
      setMonitorBucket({ requirementIds: [], candidatesByRequirement: {} });
    } finally {
      if (!cancelled) setMonitorFilterLoading(false);
    }
  };

  loadMonitorFilter();
  return () => {
    cancelled = true;
  };
}, [monitorKey, userId]);

const clearMonitorFilter = () => {
  const nextParams = new URLSearchParams(searchParams);
  nextParams.delete('monitor');
  setSearchParams(nextParams);
};

useEffect(() => {
  const fetchClaimedByCounts = async () => {
    if (!Array.isArray(showCandidateDetailsHome) || showCandidateDetailsHome.length === 0) {
      setClaimedByCounts({});
      return;
    }

    try {
      const entries = await Promise.all(
        showCandidateDetailsHome.map(async (req) => {
          const reqId = req.requirementDetails?._id;
          if (!reqId) return [null, 0];
          try {
            const response = await api.get(`/api/requirements/${reqId}/claimedByCount`);
            return [reqId, response.data.claimedByCount || 0];
          } catch (err) {
            return [reqId, req.requirementDetails?.claimedBy?.length || 0];
          }
        })
      );
      setClaimedByCounts(Object.fromEntries(entries.filter(([id]) => id)));
    } catch (err) {
      console.error('Error fetching claimedBy counts:', err);
    }
  };

  fetchClaimedByCounts();
}, [showCandidateDetailsHome]);

const fetchClaimedUsersDetails = async (requirementId, regId) => {
  try {
    const response = await api.get(`/api/requirements/${requirementId}/claimedByDetails`);
    setShowClaimedUsers(response.data.claimedUsers || []);
    setClaimsModalMeta({ regId: regId || '' });
    setShowClaimsModal(true);
  } catch (error) {
    console.error(`Error fetching claimed users for requirement ${requirementId}:`, error);
  }
};

const openProfilesModal = async (reqId, regId, mode = 'all', scopedCandidates = null) => {
  try {
    const response = await api.get(`/api/recruiters/${reqId}`);
    setRecruitersData(response.data.recruiters || []);
    const normalizedScopedCandidates = Array.isArray(scopedCandidates)
      ? normalizeCandidateList(scopedCandidates)
      : null;
      setProfilesModalMeta({
      regId: regId || '',
      mode,
      requirementId: reqId,
      scopedCandidates: normalizedScopedCandidates,
    });
    setShowProfilesModal(true);
  } catch (err) {
    const status = err.response?.status;
    const message = err.message || '';
    if (status === 404 || /not found|no recruiters/i.test(message)) {
      setRecruitersData([]);
      setProfilesModalMeta({
      regId: regId || '',
      mode,
      requirementId: reqId,
      scopedCandidates: Array.isArray(scopedCandidates)
        ? normalizeCandidateList(scopedCandidates)
        : null,
    });
      setShowProfilesModal(true);
      return;
    }
    console.error('Error loading recruiter details:', err);
  }
};

const closeProfilesModal = () => {
  setShowProfilesModal(false);
  setProfilesModalMeta({ regId: '', mode: 'all', requirementId: '', scopedCandidates: null });
  setHighlightProfileId('');
  if (searchParams.get('requirementId') || searchParams.get('profileId')) {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('requirementId');
    nextParams.delete('profileId');
    setSearchParams(nextParams, { replace: true });
    profileDeepLinkRef.current = '';
  }
};

const closeClaimsModal = () => {
  setShowClaimsModal(false);
  setShowClaimedUsers([]);
  setClaimsModalMeta({ regId: '' });
};

const openRejectedModal = async (requirementId, regId) => {
  setRejectedModalMeta({ regId: regId || '', requirementId });
  setShowRejectedModal(true);
  setRejectedLoading(true);
  try {
    const response = await getRejectedCandidates(requirementId, userId);
    setRejectedRows(response.rows || []);
  } catch (error) {
    console.error('Error loading rejected candidates:', error);
    setRejectedRows([]);
  } finally {
    setRejectedLoading(false);
  }
};

const closeRejectedModal = () => {
  setShowRejectedModal(false);
  setRejectedModalMeta({ regId: '', requirementId: '' });
  setRejectedRows([]);
};

const handleRejectedStatusUpdated = useCallback((candidateId, newStatus) => {
  setRejectedRows((prev) => prev.map((row) => (
    row.candidateId === candidateId
      ? { ...row, currentStatus: newStatus }
      : row
  )));
  triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
  requirementDetailsWithAssignedUsers();
}, [triggerTableRefresh, requirementDetailsWithAssignedUsers]);

useEffect(() => {
  if (!userId) return;
  if (isRequirementsListView) {
    requirementDetailsWithAssignedUsers();
  }
  if (view === 'assign') loadAssignRequirements(false);
  if (view === 'profiles') loadProfileStats(false);
}, [userId, view, isRequirementsListView, tableRefresh.requirements, tableRefresh.candidates, loadAssignRequirements, loadProfileStats, requirementDetailsWithAssignedUsers]);

useEffect(() => {
  if (!focusedRequirementId || !isRequirementsListView) return undefined;

  const linkKey = `${focusedRequirementId}:${focusedProfileId}`;
  if (profileDeepLinkRef.current === linkKey) return undefined;

  const matchedRow = (showCandidateDetailsHome || []).find(
    (row) => String(row.requirementDetails?._id) === focusedRequirementId,
  );
  const regId = matchedRow?.requirementDetails?.regId || '';

  profileDeepLinkRef.current = linkKey;
  openProfilesModal(focusedRequirementId, regId, 'all');
  if (focusedProfileId) setHighlightProfileId(focusedProfileId);

  return undefined;
}, [
  focusedRequirementId,
  focusedProfileId,
  isRequirementsListView,
  showCandidateDetailsHome,
]);

useEffect(() => {
  if (!focusedProfileId || !showProfilesModal) return undefined;
  if (String(profilesModalMeta.requirementId) !== String(focusedRequirementId)) return undefined;

  const openKey = `modal:${focusedRequirementId}:${focusedProfileId}`;
  if (profileModalDeepLinkRef.current === openKey) return undefined;

  let cancelled = false;
  const timer = window.setTimeout(() => {
    if (cancelled) return;
    profileModalDeepLinkRef.current = openKey;
    CandidateData(focusedProfileId);
  }, 650);

  return () => {
    cancelled = true;
    window.clearTimeout(timer);
  };
}, [
  focusedProfileId,
  focusedRequirementId,
  showProfilesModal,
  profilesModalMeta.requirementId,
]);

useEffect(() => {
  if (!showProfilesModal || !profilesModalMeta.requirementId) return;
  reloadOpenProfilesModal(profilesModalMeta.requirementId);
}, [showProfilesModal, profilesModalMeta.requirementId, reloadOpenProfilesModal]);

useEffect(() => {
  if (view !== 'profiles') {
    setSubmissionPanel('');
    setSubmissionSearch('');
    setSubmissionRecruiterDetail(null);
  }
}, [view]);
// const options = [
//   { label: 'Select', value: '' },
//   { label: 'Ornnova Screen Selected', value: 'Ornnova Screen Selected' },
//   { label: 'Shared with Client', value: 'Shared with Client',parent: 'Ornnova Screen Selected' },
//   { label: 'Selected', value: 'Selected', parent: 'Ornnova Screen Selected' },
//   { label: 'Rejected', value: 'Rejected', parent: 'Ornnova Screen Selected' },
//   { label: 'Selected', value: 'Selected', parent: 'Shared with Client' },
//   { label: 'Rejected', value: 'Rejected', parent: 'Shared with Client' },
//   { label: 'L1 Pending', value: 'L1 Pending', parent: 'Selected' },
//   { label: 'L1 Selected', value: 'L1 Selected', parent: 'L1 Pending' },
//   { label: 'L1 Rejected', value: 'L1 Rejected', parent: 'L1 Pending' },
//   { label: 'L2 Pending', value: 'L2 Pending', parent: 'L1 Selected' },
//   { label: 'L2 Selected', value: 'L2 Selected', parent: 'L2 Pending' },
//   { label: 'L2 Rejected', value: 'L2 Rejected', parent: 'L2 Pending' },
//   { label: 'Onboard Confirmation', value: 'Onboard Confirmation', parent: 'L2 Selected' },
//   { label: 'Onboarded', value: 'Onboarded', parent: 'Onboard Confirmation' },
//   { label: 'Rejected/Declined', value: 'Rejected/Declined', parent: 'Onboard Confirmation' },
// ];

// // Function to filter options based on the selected value
// const getFilteredOptions = () => {
//   if (!selectedValue) {
//       // Show the top-level options (first level)
//       return options.filter(option => !option.parent);
//   }

//   // Find the parent option for the selected value
//   const parentOption = options.find(opt => opt.value === selectedValue);

//   // If a valid parent is found, show options dependent on the selected value
//   return options.filter(option => option.parent === selectedValue || option.value === selectedValue);
// };

const handleStatusChange = (e) => {
  const nextStatus = e.target.value;
  setSelectedStatus(nextStatus);
  if (!statusRequiresInterviewDate(nextStatus)) {
    setStatusInterviewDate('');
  }
};

// Make sure candidateId is properly passed and used
const handleStatusRemarkAdded = (updatedStatusEntry, updatedCandidate) => {
  if (updatedCandidate) {
    setCandidateDetails(normalizeCandidateRecord(updatedCandidate));
    return;
  }
  if (updatedStatusEntry?._id) {
    setCandidateDetails((prev) => mergeCandidateStatusRemarkUpdate(
      prev,
      updatedStatusEntry._id,
      updatedStatusEntry,
    ));
  }
};

const postStatus = async (id) => {
  await submitStatusUpdate({
    api,
    candidateId: id,
    selectedStatus,
    statusRemark,
    statusInterviewDate,
    updatedBy: userId,
    onSuccess: async (responseData) => {
      setSelectedStatus('');
      setStatusInterviewDate('');
      setStatusRemark('');

      const updated = applyCandidateStatusUpdate({
        responseData,
        candidateId: id,
        setRecruitersData,
        setProfilesModalMeta,
        setCandidateDetails: setCandidateDetails,
        setRequirementRows: setShowCandidateDetailsHome,
        setSelectedCandidates,
      });

      await reloadOpenProfilesModal(profilesModalMeta.requirementId);
      await requirementDetailsWithAssignedUsers();

      if (showUserModal && userUploadsModalMeta.requirementId) {
        await refreshUserUploadsCandidates(userUploadsModalMeta.requirementId);
      }

      if (!updated && id) {
        await CandidateData(id);
      }

      triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
    },
  });
};

const updateClaim = async (id) => {
  const user = {
    userId:userId,
    claimedDate: new Date(),
  };

  try {
    const { data: result } = await api.put(`/claim/${id}`, user);
    if (result.status === "Success") {
      showSuccess(result.msg || 'Requirement claimed successfully ✓');
      triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
    } else {
      showError(result.msg || 'Failed to claim requirement. Please try again.');
    }
  } catch (error) {
    console.error('Error updating claim:', error);
    showError(getApiErrorMessage(error, 'Error updating claim. Please try again later.'));
  }
};

const handleUnclaim = async (id) => {
  try {
    const result = await unclaimRequirementApi(id, { userId });
    if (result.status === 'Success') {
      showSuccess(result.msg || 'Requirement unclaimed successfully ✓');
      triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
    } else {
      showError(result.msg || 'Unable to unclaim this requirement.');
    }
  } catch (error) {
    showError(getApiErrorMessage(error, 'Unable to unclaim this requirement.'));
  }
};

  const pageMeta = {
    requirements: {
      title: 'My Requirements',
      subtitle: 'Requirements you created. Use Upload to submit candidates or manage your team pipeline.',
      backTo: '/dashboard',
      breadcrumbs: [
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'My Requirements' },
      ],
    },
    'all-requirements': {
      title: 'Requirements',
      subtitle: 'Requirements you created or that are assigned to you. Includes admin-assigned client requirements.',
      backTo: '/dashboard',
      breadcrumbs: [
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Requirements' },
      ],
    },
    assign: {
      title: 'Assign Requirement',
      subtitle: 'Assign open requirements to recruiters on your team.',
      backTo: '/team/requirements',
      breadcrumbs: [
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Requirements', path: '/team/requirements' },
        { label: 'Assign Requirement' },
      ],
    },
    profiles: {
      title: 'Source Profile Submissions',
      subtitle: 'Track how many candidates your team has uploaded. This is not the same as Assigned Recruiters or Assigned Clients in the sidebar.',
      backTo: '/team/requirements',
      breadcrumbs: [
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Requirements', path: '/team/requirements' },
        { label: 'Source Profile Submissions' },
      ],
    },
  };
  const meta = pageMeta[view] || pageMeta.requirements;
  const monitorFilterLabel = MONITOR_FILTER_LABELS[monitorKey] || '';

  return (
 <PageShell
  title={meta.title}
  subtitle={meta.subtitle}
  breadcrumbs={meta.breadcrumbs}
  backTo={meta.backTo}
  actions={isRequirementsListView ? (
    <Button variant="primary" className="hr-btn-primary" onClick={() => openFormModal('create-tl-requirement')}>
      + Create Requirement
    </Button>
  ) : null}
>

{view === 'assign' && (
  <>
    <div className="hr-card" style={{ padding: '16px' }}>
    <Table style={{ textAlign: 'center' }} bordered hover responsive className="hr-data-table hr-table table-sm hr-requirement-list-table mb-0">
      <thead>
        <tr>
          <th>Sno</th>
          <th>Priority</th>
          <th>Reg Id</th>
          <th>Client</th>
          <th>Requirement Type</th>
          <th>Source</th>
          <th>Start Date</th>
          <th>Type Of Contract</th>
          <th>Assigns</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {sortedAssignRequirements.length > 0 ? (
          sortedAssignRequirements.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td><PriorityBadge priority={item.requirement?.priority} /></td>
              <td>
                <Link onClick={() => viewRequirement(item.requirement._id)} style={{ textDecoration: 'none' }}>
                  <b>{item.requirement.regId}</b>
                </Link>
              </td>
              <td>{item.requirement.client}</td>
              <td>
                <RequirementTypeSelect
                  requirementId={item.requirement._id}
                  value={item.requirement.requirementtype}
                  onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(item.requirement._id, nextType, updatedRequirement)}
                />
              </td>
              <td>
                <span className={`badge ${getRequirementSourceBadgeClass(getRequirementSourceFromRow(item), item)}`}>
                  {getRequirementSourceFromRow(item)}
                </span>
              </td>
              <td>{new Date(item.requirement.startDate).toLocaleDateString()}</td>
              <td>{item.requirement.typeOfContract}</td>
              <td>
                <b style={{
                  backgroundColor: item.assignedCount === item.totalTeamCount ? 'MediumSeaGreen' : 'orange',
                  color: item.assignedCount === item.totalTeamCount ? 'white' : 'black',
                  borderRadius: '30px',
                  padding: '5px',
                  border: '1px solid black',
                }}
                >
                  {item.assignedCount}/{item.totalTeamCount}
                </b>
              </td>
              <td>
                <Button
                  onClick={() => userDetailstoAssignClient(item.requirement._id)}
                  style={{ padding: '5px', borderRadius: '8px', backgroundColor: 'lightseagreen', color: 'white', border: '1.5px solid black', fontWeight: 'bold' }}
                >
                  Assign
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="9">No requirements found</td>
          </tr>
        )}
      </tbody>
    </Table>
    </div>
  </>
)}

{view === 'profiles' && (
  <>
    <div className="hr-tl-submission-grid">
      <button
        type="button"
        className={`hr-stat-card hr-stat-card-button${submissionPanel === 'today' ? ' hr-stat-card-active' : ''}`}
        onClick={() => openSubmissionPanel('today')}
      >
        <div className="hr-stat-card-top">
          <span className="hr-stat-card-icon">📅</span>
          <span className="hr-stat-card-accent hr-stat-accent-green" />
        </div>
        <p className="hr-stat-card-label">Uploaded Today</p>
        <h3 className="hr-stat-card-value">{todayCount}</h3>
        <p className="hr-stat-card-subtitle">Source profiles submitted today</p>
      </button>

      <button
        type="button"
        className={`hr-stat-card hr-stat-card-button${submissionPanel === 'total' ? ' hr-stat-card-active' : ''}`}
        onClick={() => openSubmissionPanel('total')}
      >
        <div className="hr-stat-card-top">
          <span className="hr-stat-card-icon">📊</span>
          <span className="hr-stat-card-accent hr-stat-accent-orange" />
        </div>
        <p className="hr-stat-card-label">Total Uploaded</p>
        <h3 className="hr-stat-card-value">{totalCount}</h3>
        <p className="hr-stat-card-subtitle">All active candidate submissions</p>
      </button>

      <button
        type="button"
        className={`hr-stat-card hr-stat-card-button${submissionPanel === 'recruiters' ? ' hr-stat-card-active' : ''}`}
        onClick={() => openSubmissionPanel('recruiters')}
      >
        <div className="hr-stat-card-top">
          <span className="hr-stat-card-icon">👥</span>
          <span className="hr-stat-card-accent hr-stat-accent-blue" />
        </div>
        <p className="hr-stat-card-label">By Recruiter</p>
        <h3 className="hr-stat-card-value">View</h3>
        <p className="hr-stat-card-subtitle">Submissions broken down per recruiter</p>
      </button>

      <Link to="/team/clients" className="hr-stat-card hr-stat-card-link">
        <div className="hr-stat-card-top">
          <span className="hr-stat-card-icon">🏢</span>
          <span className="hr-stat-card-accent hr-stat-accent-gray" />
        </div>
        <p className="hr-stat-card-label">Assigned Clients</p>
        <h3 className="hr-stat-card-value">Open</h3>
        <p className="hr-stat-card-subtitle">Same list as sidebar → Assigned Clients</p>
      </Link>
    </div>

    {submissionPanel && (
      <div className="hr-submission-panel hr-card">
        <div className="hr-section-toolbar">
          <h3 className="hr-section-title" style={{ margin: 0 }}>
            {submissionPanel === 'today' && 'Uploaded Today'}
            {submissionPanel === 'total' && 'Total Uploaded'}
            {submissionPanel === 'recruiters' && 'By Recruiter'}
          </h3>
          <input
            type="search"
            className="hr-search form-control"
            placeholder={submissionPanel === 'recruiters' ? 'Search by name, email or code' : 'Search candidates'}
            value={submissionSearch}
            onChange={(e) => setSubmissionSearch(e.target.value)}
            aria-label="Search submissions"
          />
        </div>

        {submissionPanel === 'recruiters' && (
          <>
            {filteredSubmissionRecruiters.length > 0 ? (
              <Table style={{ textAlign: 'center' }} bordered hover responsive className="hr-data-table mb-0">
                <thead>
                  <tr>
                    <th>Emp Code</th>
                    <th>Recruiter Name</th>
                    <th>Uploaded Today</th>
                    <th>Total Uploaded</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubmissionRecruiters.map((recruiter) => (
                    <tr key={recruiter.recruiterId}>
                      <td>{recruiter.recruiterCode}</td>
                      <td>{recruiter.recruiterName}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setSubmissionRecruiterDetail({ recruiter, type: 'today' })}
                        >
                          <b>{recruiter.todaysCandidates}</b>
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setSubmissionRecruiterDetail({ recruiter, type: 'total' })}
                        >
                          <b>{recruiter.totalCandidates}</b>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="text-center mb-0">No recruiter data available.</p>
            )}

            {submissionRecruiterDetail && (
              <div className="hr-submission-detail">
                <h4 className="hr-section-title">
                  {submissionRecruiterDetail.recruiter.recruiterName} —{' '}
                  {submissionRecruiterDetail.type === 'today' ? 'Uploaded Today' : 'Total Uploaded'}
                </h4>
                <Table style={{ textAlign: 'center' }} bordered hover responsive className="hr-data-table mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Skills</th>
                      <th>Total YOE</th>
                      <th>LWD</th>
                      <th>ECTC</th>
                      <th>Uploaded On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(
                      submissionRecruiterDetail.type === 'today'
                        ? submissionRecruiterDetail.recruiter.todaysCandidatesData
                        : submissionRecruiterDetail.recruiter.totalCandidatesData
                    )?.length > 0 ? (
                      (submissionRecruiterDetail.type === 'today'
                        ? submissionRecruiterDetail.recruiter.todaysCandidatesData
                        : submissionRecruiterDetail.recruiter.totalCandidatesData
                      ).map((candidate, index) => (
                        <tr key={candidate._id || index}>
                          <td>{candidate.firstName}{candidate.lastName}</td>
                          <td>{candidate.candidateSkills}</td>
                          <td>{candidate.totalYoe}</td>
                          <td>{formatLwdDisplay(candidate.lwd)}</td>
                          <td>{candidate.ectc}</td>
                          <td>{candidate.uploadedOn ? new Date(candidate.uploadedOn).toLocaleDateString() : '—'}</td>
                          <td>
                            <ActionIcon
                              variant="view"
                              src="/Images/view.svg"
                              alt="View candidate"
                              onClick={() => CandidateData(candidate._id)}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No source profiles uploaded.</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </>
        )}

        {submissionPanel === 'today' && (
          <Table style={{ textAlign: 'center' }} bordered hover responsive className="hr-data-table mb-0">
            <thead>
              <tr>
                <th>Recruiter</th>
                <th>Name</th>
                <th>Skills</th>
                <th>Total YOE</th>
                <th>LWD</th>
                <th>ECTC</th>
                <th>Uploaded On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTodayCandidates.length > 0 ? (
                filteredTodayCandidates.map((candidate, index) => (
                  <tr key={candidate._id || index}>
                    <td>{candidate.recruiterName}</td>
                    <td>{candidate.firstName}{candidate.lastName}</td>
                    <td>{candidate.candidateSkills}</td>
                    <td>{candidate.totalYoe}</td>
                    <td>{formatLwdDisplay(candidate.lwd)}</td>
                    <td>{candidate.ectc}</td>
                    <td>{candidate.uploadedOn ? new Date(candidate.uploadedOn).toLocaleDateString() : '—'}</td>
                    <td>
                      <ActionIcon
                        variant="view"
                        src="/Images/view.svg"
                        alt="View candidate"
                        onClick={() => CandidateData(candidate._id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No source profiles uploaded today.</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}

        {submissionPanel === 'total' && (
          <Table style={{ textAlign: 'center' }} bordered hover responsive className="hr-data-table mb-0">
            <thead>
              <tr>
                <th>Recruiter</th>
                <th>Name</th>
                <th>Skills</th>
                <th>Total YOE</th>
                <th>LWD</th>
                <th>ECTC</th>
                <th>Uploaded On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTotalCandidates.length > 0 ? (
                filteredTotalCandidates.map((candidate, index) => (
                  <tr key={candidate._id || index}>
                    <td>{candidate.recruiterName}</td>
                    <td>{candidate.firstName}{candidate.lastName}</td>
                    <td>{candidate.candidateSkills}</td>
                    <td>{candidate.totalYoe}</td>
                    <td>{formatLwdDisplay(candidate.lwd)}</td>
                    <td>{candidate.ectc}</td>
                    <td>{candidate.uploadedOn ? new Date(candidate.uploadedOn).toLocaleDateString() : '—'}</td>
                    <td>
                      <ActionIcon
                        variant="view"
                        src="/Images/view.svg"
                        alt="View candidate"
                        onClick={() => CandidateData(candidate._id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No source profiles uploaded.</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    )}
  </>
)}

{isRequirementsListView && (
<>
<div className="hr-section-toolbar">
  <h3 className="hr-section-title">{view === 'requirements' ? 'My Requirements' : 'Requirements'}</h3>
</div>
{monitorKey && (
  <div className="alert alert-info d-flex flex-wrap justify-content-between align-items-center gap-2" role="status">
    <span>
      Showing requirements for Today Work Monitor: <strong>{monitorFilterLabel}</strong>
      {monitorFilterLoading ? ' (loading...)' : ''}
    </span>
    <Button variant="outline-secondary" size="sm" onClick={clearMonitorFilter}>
      Clear monitor filter
    </Button>
  </div>
)}

<TLRequirementFilterBar
  searchQuery={searchQuery}
  onSearchChange={setSearchQuery}
  fromDate={uploadedFromDate}
  toDate={uploadedToDate}
  onFromChange={setUploadedFromDate}
  onToChange={setUploadedToDate}
  onClear={handleClearRequirementFilters}
/>

<div className="hr-card" style={{ padding: '16px' }}>
  <div className="hr-role-filters">
    <DropdownButton
      title={getTypeFilterTitle()}
      variant="outline-secondary"
      id="tl-requirement-type-filter"
      className="hr-requirement-type-filter"
    >
      <Dropdown.Item
        as="div"
        key="all"
        onClick={(e) => e.stopPropagation()}
        style={{ fontWeight: 'bold' }}
      >
        <input
          type="checkbox"
          id="tl-checkbox-all"
          checked={selectedTypes.length === requirementTypes.length}
          onChange={() => handleTypeCheckboxChange('all')}
        />
        <label htmlFor="tl-checkbox-all" style={{ marginLeft: '10px' }}>
          All
        </label>
      </Dropdown.Item>
      {requirementTypes.map((type) => (
        <Dropdown.Item
          as="div"
          key={type}
          onClick={(e) => e.stopPropagation()}
          style={{ fontWeight: 'bold' }}
        >
          <input
            type="checkbox"
            id={`tl-checkbox-${type}`}
            checked={selectedTypes.includes(type)}
            onChange={() => handleTypeCheckboxChange(type)}
          />
          <label htmlFor={`tl-checkbox-${type}`} style={{ marginLeft: '10px' }}>
            {type}
          </label>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  </div>

  <div className="table-responsive">
  <Table style={{ textAlign: "center" }} bordered hover responsive className="hr-data-table hr-table table-sm hr-requirement-list-table mb-0">
                <thead>
                    <tr>
                        <th>Priority</th>
                        <th>Requirement ID</th>
                        <th>Client</th>
                        <th>Role</th>
                        <th>Type Of Contract</th>
                        <th>Requirement Type</th>
                        <th>Source</th>
                        <th>Start Date</th>
                        <th>Uploaded On</th> 
                        <th>Assigned Team Members</th>
                        <th>Uploaded Today</th>
                        <th>Your Uploads</th>
                        <th>Team Uploads</th>
                        <th>Total Uploads</th>
                        <th>No Action Taken</th>
                        <th>Action Taken</th>
                        <th>Rejected</th>
                        <th>No of Claims</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
  {(filteredData || []).length === 0 ? (
    <tr>
      <td colSpan={19} className="hr-empty-state">
        {monitorKey
          ? `No requirements match the ${monitorFilterLabel} queue for today.`
          : view === 'requirements'
          ? 'No requirements found. Create one with + Create Requirement.'
          : 'No requirements found. Create one with + Create Requirement, or ask Admin to assign requirements to you.'}
      </td>
    </tr>
  ) : (filteredData || []).map((req, index) => {
    const requirementDetails = req.requirementDetails;
    const requirementMongoId = requirementDetails?._id;
    const primaryAction = getTlRequirementPrimaryActionDisplay(requirementDetails);

    return (
    <React.Fragment key={requirementMongoId || index}>
    <tr>
      <td><PriorityBadge priority={req.requirementDetails?.priority} /></td>
      <td>
        <Link
          style={{ textDecoration: "none" }}
          onClick={() => viewRequirement(req.requirementDetails?._id)}
        >
          <b>{req.requirementDetails?.regId}</b>
        </Link>
      </td>
      <td>{req.requirementDetails?.client}</td>
      <td>{req.requirementDetails?.role}</td>
      <td>{req.requirementDetails?.typeOfContract}</td>
      <td>
        <RequirementTypeSelect
          requirementId={req.requirementDetails?._id}
          value={req.requirementDetails?.requirementtype}
          onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(req.requirementDetails?._id, nextType, updatedRequirement)}
        />
      </td>
      <td>
        <span className={`badge ${getRequirementSourceBadgeClass(getRequirementSourceFromRow(req), req)}`}>
          {getRequirementSourceFromRow(req)}
        </span>
      </td>
      <td>{new Date(req.requirementDetails?.startDate).toLocaleDateString()}</td>
      <td>{new Date(req.requirementDetails?.uploadedDate).toLocaleDateString()}</td>

      <td>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>
            {req.assignedUsernames?.length > 0 ? (
              req.assignedUsernames.join(", ")
            ) : (
              <strong>No users assigned</strong>
            )}
          </span>
          <div style={{ width: "20%", height: "20%" }}>
            <Button onMouseMove={(e)=> { e.target.style.backgroundColor="lightpink";e.target.style.color="black"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor= req.userCount === 0 ? "indianred" : "lightslategray";e.target.style.color="white"; }}
              style={{
                backgroundColor: req.userCount === 0 ? "indianred" : "lightslategray",
                borderRadius: "20px",
                textAlign: "center",
                border: "1px solid black",
                fontWeight:"bold"
              }}
              onClick={() => handleOpenAssignModal(req.requirementDetails?._id, req.requirementDetails)}
            >
              {req.userCount}
            </Button>
          </div>
        </div>
      </td>

      {/* Today Candidates Count */}
      <td>
        {req.todayCandidateCount > 0 ? (
          <div onMouseMove={(e)=> { e.target.style.backgroundColor="gray";e.target.style.color="white"; }}onMouseLeave={(e)=> { e.target.style.backgroundColor="";e.target.style.color="blue"; }}
            style={{ cursor: "pointer", color: "blue",fontWeight:"bold",padding:"10px",borderRadius:"10px" }}
            onClick={() => handleShowCandidates(req.combinedTodayCandidates, req.requirementDetails?.regId)}
          >
           {req.todayCandidateCount}
          </div>
        ) : (
          <strong>0</strong>
        )}
      </td>
       {/* User Candidates Count */}
       <td>
        {req.userCandidatesCount > 0 ? (
          <div onMouseMove={(e)=> { e.target.style.backgroundColor="gray";e.target.style.color="white"; }}onMouseLeave={(e)=> { e.target.style.backgroundColor="";e.target.style.color="blue"; }}
          style={{ cursor: "pointer", color: "blue",fontWeight:"bold",padding:"10px",borderRadius:"10px" }}
          onClick={() => handleShowUserCandidates(
            req.userActiveCandidatesDetails || [],
            req.requirementDetails?.regId,
            req.requirementDetails?._id,
          )}
          >
            {req.userCandidatesCount}
          </div>
        ) : (
          <strong>0</strong>
        )}
      </td>

      {/* Team Candidates Count */}
      <td>
        {req.teamCandidatesCount > 0 ? (
          <div onMouseMove={(e)=> { e.target.style.backgroundColor="gray";e.target.style.color="white"; }}onMouseLeave={(e)=> { e.target.style.backgroundColor="";e.target.style.color="blue"; }}
          style={{ cursor: "pointer", color: "blue",fontWeight:"bold",padding:"10px",borderRadius:"10px" }}
          onClick={() => handleShowTeamCandidates(req.totalTeamCandidatesDetails, req.requirementDetails?.regId)}
          >
            {req.teamCandidatesCount}
          </div>
        ) : (
          <strong>0</strong>
        )}
      </td>

      {/* Total Candidates Count */}
      <td>
        {req.totalCandidateCount > 0 ? (
          <button
            type="button"
            className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
            onClick={() => openProfilesModal(
              req.requirementDetails?._id,
              req.requirementDetails?.regId,
              'all',
              req.totalCandidatesDetails || []
            )}
          >
            <strong>{req.totalCandidateCount}</strong>
          </button>
        ) : (
          <strong>0</strong>
        )}
      </td>

      <td>
        {(() => {
          const noActionCandidates = filterNoActionTakenCandidates(req.totalCandidatesDetails || []);
          const noActionCount = noActionCandidates.length;
          return noActionCount > 0 ? (
            <button
              type="button"
              className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn is-alert"
              onClick={() => openProfilesModal(
                req.requirementDetails?._id,
                req.requirementDetails?.regId,
                'no-action',
                noActionCandidates
              )}
            >
              <strong>{noActionCount}</strong>
            </button>
          ) : (
            <strong>0</strong>
          );
        })()}
      </td>

      <td>
        {(() => {
          const actionTakenCount = countActionTakenCandidates(req.totalCandidatesDetails || []);
          return actionTakenCount > 0 ? (
            <button
              type="button"
              className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
              onClick={() => openProfilesModal(req.requirementDetails?._id, req.requirementDetails?.regId, 'all')}
            >
              <strong>{actionTakenCount}</strong>
            </button>
          ) : (
            <strong>0</strong>
          );
        })()}
      </td>

      <td>
        {(() => {
          const rejectedCount = req.rejectedCandidatesCount ?? countRejectedCandidates(req.totalCandidatesDetails || []);
          return rejectedCount > 0 ? (
            <button
              type="button"
              className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn is-alert"
              onClick={() => openRejectedModal(req.requirementDetails?._id, req.requirementDetails?.regId)}
            >
              <strong>{rejectedCount}</strong>
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn is-zero"
              onClick={() => openRejectedModal(req.requirementDetails?._id, req.requirementDetails?.regId)}
            >
              <strong>0</strong>
            </button>
          );
        })()}
      </td>

      <td>
        <button
          type="button"
          className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
          onClick={() => fetchClaimedUsersDetails(req.requirementDetails?._id, req.requirementDetails?.regId)}
        >
          <strong>{claimedByCounts[req.requirementDetails?._id] ?? req.requirementDetails?.claimedBy?.length ?? 0}</strong>
        </button>
      </td>

      <td>
  <div className="hr-table-actions hr-req-row-actions d-flex flex-wrap justify-content-center align-items-center gap-1">
    <button
      type="button"
      className={`hr-req-row-action hr-req-row-action--expand${openItems[requirementMongoId] ? ' is-open' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        toggleAccordion(requirementMongoId);
      }}
      title="Expand Requirement"
      aria-label="Expand Requirement"
    >
      <Image src="./Images/expand.svg" alt="" />
      <span>Expand</span>
    </button>
    {canEditRequirement(requirementDetails, userId) && (
      <button
        type="button"
        className="hr-req-row-action hr-req-row-action--delete"
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteRequirement(requirementMongoId, requirementDetails?.regId);
        }}
        title="Delete"
        aria-label="Delete"
      >
        <Image src="./Images/trash.svg" alt="" />
        <span>Delete</span>
      </button>
    )}
    <button
      type="button"
      style={{
        textDecoration: "none",
        border: '0px',
        borderRadius: '20px',
        fontWeight: "bold",
        padding: "5px 10px",
        color: primaryAction.tone === 'idle' ? '#495057' : 'white',
        cursor: primaryAction.blocked ? 'not-allowed' : 'pointer',
        backgroundColor: getTlRequirementPrimaryActionButtonColor(primaryAction.tone),
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (primaryAction.blocked) {
          return;
        }
        if (canClaimRequirement(requirementDetails)) {
          updateClaim(requirementDetails._id);
          return;
        }
        if (canUploadToRequirement(requirementDetails)) {
          openFormModal('upload-candidate', { reqId: requirementDetails._id, workflow: requirementDetails.workflow });
          return;
        }
        showWarning(getUploadDisabledMessage(requirementDetails));
      }}
      onMouseMove={(e) => {
        if (!primaryAction.blocked) {
          e.target.style.backgroundColor = getTlRequirementPrimaryActionButtonColor(primaryAction.tone, { hover: true });
          e.target.style.padding = "7px 12px";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = getTlRequirementPrimaryActionButtonColor(primaryAction.tone);
        e.target.style.padding = "5px 10px";
      }}
    >
      {primaryAction.label}
    </button>
    {canUnclaimRequirement(requirementDetails) && (
      <button
        type="button"
        className="btn btn-outline-warning btn-sm"
        onClick={(e) => {
          e.stopPropagation();
          handleUnclaim(requirementDetails._id);
        }}
      >
        Unclaim
      </button>
    )}
  </div>
</td>
    </tr>
    {expandedId === requirementMongoId && (
      <tr>
        <td colSpan={19}>
          <Accordion activeKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Body>
                <Table bordered hover responsive className="table-sm" style={{ textAlign: 'center' }}>
                  <thead>
                    <tr>
                      <th>Employee Name</th>
                      <th>Source Profile Name</th>
                      <th>Role</th>
                      <th>ECTC</th>
                      <th>LWD</th>
                      <th>Uploaded Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recruitersData.length === 0 ? (
                      <tr>
                        <td colSpan={8}>No source profiles for this requirement.</td>
                      </tr>
                    ) : recruitersData.map((group, groupIndex) => (
                      <React.Fragment key={group.recruiter?._id || groupIndex}>
                        {group.candidates.length > 0 ? (
                          group.candidates.map((candidate, candidateIndex) => {
                            const persistedStatus = getPersistedCandidateStatus(candidate);
                            return (
                              <tr key={candidate._id || candidateIndex}>
                                {candidateIndex === 0 && (
                                  <td rowSpan={group.candidates.length}>
                                    {group.recruiter?.EmployeeName || group.recruiter?.EmpCode}
                                  </td>
                                )}
                                <td>{candidate.firstName} {candidate.lastName}</td>
                                <td>{candidate.role}</td>
                                <td>{candidate.ectc}</td>
                                <td>{formatLwdDisplay(candidate.lwd)}</td>
                                <td>{formatDisplayDate(candidate.uploadedOn)}</td>
                                <td>
                                  <StatusBadge status={persistedStatus} useStoredLabel />
                                </td>
                                <td>
                                  <ActionIcon
                                    variant="view"
                                    src="/Images/view.svg"
                                    alt="View candidate"
                                    onClick={() => CandidateData(candidate._id)}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td>{group.recruiter?.EmpCode}</td>
                            <td>{group.recruiter?.EmployeeName}</td>
                            <td colSpan={6}>No Source Profiles</td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </td>
      </tr>
    )}
    </React.Fragment>
    );
  })}
</tbody>

            </Table>
  </div>
</div>
</>
)}

      <RequirementCandidatesModal
        show={candidatesListModal.show}
        onHide={closeCandidatesListModal}
        title={candidatesListModal.title}
        subtitle={candidatesListModal.subtitle}
        candidates={candidatesListModal.candidates}
        initialStatusFilter={candidatesListModal.statusFilter}
        onViewCandidate={CandidateData}
      />

      <RequirementClaimsModal
        show={showClaimsModal}
        onHide={closeClaimsModal}
        subtitle={claimsModalMeta.regId ? `Req ID: ${claimsModalMeta.regId}` : ''}
        claimedUsers={showClaimedUsers}
      />

      <RequirementRecruitersModal
        show={showProfilesModal}
        onHide={closeProfilesModal}
        title={profilesModalMeta.mode === 'no-action' ? 'No Action Taken' : 'Source Profiles'}
        subtitle={profilesModalMeta.regId ? `Req ID: ${profilesModalMeta.regId}` : ''}
        recruitersData={recruitersData}
        noActionFilter={profilesModalMeta.mode === 'no-action'}
        scopedCandidates={profilesModalMeta.scopedCandidates}
        onViewCandidate={CandidateData}
        highlightProfileId={highlightProfileId}
      />

      <RequirementRejectedModal
        show={showRejectedModal}
        onHide={closeRejectedModal}
        subtitle={rejectedModalMeta.regId ? `Req ID: ${rejectedModalMeta.regId}` : ''}
        rows={rejectedRows}
        loading={rejectedLoading}
        editableStatus
        updatedBy={userId}
        onStatusUpdated={handleRejectedStatusUpdated}
      />

<Modal
style={{backgroundColor:"lightgray"}}
        size="lg"
        show={lgShow && view !== 'profiles'}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          <h3>
          <img
            style={{ width: "30px", margin: "10px" }}
            src='/Images/icon.png'
            alt="icon"
          />
          <b style={{ fontFamily: "monospace" }}>By Recruiter</b>
        </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div>
      <center>
       

      {/* Displaying Team Information */}
      {teamData.length > 0 && (
        <div>
          <Table style={{textAlign:"center"}} responsive >
            <thead>
              <tr>
              <th>Employee Code</th>
                <th>Employee Name</th>
                <th>Email</th>
                
              </tr>
            </thead>
            <tbody>
              {teamData.map((team, index) => (
                <tr key={index}>
                  <td><Link style={{textDecoration:"none"}} onClick={()=> readUserDatafun(team._id)}><b>{team.EmpCode}</b></Link></td>
                  <td>{team.EmployeeName}</td>
                  <td>{team.Email}</td> 
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      </center>
      <center>
      <Row>
    <Col>
  {showUserData && showUserData.userDetails && (
    <Modal  style={{backgroundColor:"lightgray",opacity:"98%"}}
    show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <strong className="me-auto">
          <b style={{ fontFamily: "monospace", margin: "5px" }}>
            Employee Name:
          </b>
          {showUserData.userDetails.EmployeeName || "N/A"}
        </strong>
        <small>
          <b style={{ fontFamily: "monospace", margin: "5px" }}>Emp Code:</b>
          {showUserData.userDetails.EmpCode || "N/A"}
        </small>
      </Modal.Header>
      <Modal.Body>
        <center>
          {showUserData.userDetails.ProfilePic ? (
            <img
              style={{ width: "200px" }}
              src={`${API_BASE_URL}/${showUserData.userDetails.ProfilePic}`}
              alt="Profile"
            />
          ) : (
            <p>No Profile Picture Available</p>
          )}
        </center>
        <hr />
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>Email:</b>
          {showUserData.userDetails.Email || "N/A"}
        </p>
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>
            User Type:
          </b>
          {showUserData.userDetails.UserType || "N/A"}
        </p>
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>Status:</b>
          {showUserData.userDetails.Status || "N/A"}
        </p>
        <hr />
       
      </Modal.Body>
    </Modal>
  )}
</Col>
</Row>
      </center>

    </div>
        </Modal.Body>
      </Modal>

      <Modal size="fullscreen" show={showfl && view !== 'assign'} onHide={() => setShowfl(false)} aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          <h3> <img style={{ width: "30px", margin: "10px" }}src='/Images/icon.png'alt="icon"/> <b style={{ fontFamily: "monospace" }}>Assign Requirements</b></h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
         {/* Search input */}
      {/* <input type="search"placeholder="🔍 Search by Client Name"value={searchTerm}onChange={handleSearchChange}style={{ marginBottom: "20px", width: "300px",padding:"10px",border:"2px solid gray",borderRadius:"20px" }}/> */}
      {/* Render table only if showfl is true */}
      {showfl && (
        <Table style={{textAlign:"center"}} responsive>
          <thead>
            <tr>
              <th>Sno</th>
              <th>Reg Id</th>
              <th>Client</th>
              <th>Requirement Type</th>
              <th>Start Date</th>
              <th>Type Of Contract</th>
              <th>Assigns</th>
              <th>Action</th>            
            </tr>
          </thead>
          <tbody >
            {sortedAssignRequirements.length > 0 ? (
              sortedAssignRequirements.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <Link onClick={() => { viewRequirement(item.requirement._id) }} style={{ textDecoration: "none" }}>
                      <b>{item.requirement.regId}</b>
                    </Link>
                  </td>
                  <td>{item.requirement.client}</td>
                  <td>
                <RequirementTypeSelect
                  requirementId={item.requirement._id}
                  value={item.requirement.requirementtype}
                  onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(item.requirement._id, nextType, updatedRequirement)}
                />
              </td>
                  <td>{new Date(item.requirement.startDate).toLocaleDateString()}</td>
                  <td>{item.requirement.typeOfContract}</td>
                  <td><b style={{backgroundColor: ` ${item.assignedCount === item.totalTeamCount ? "MediumSeaGreen" : "orange"}`,color:`${item.assignedCount === item.totalTeamCount ? "white" : "black"}`,borderRadius: "30px",padding: "5px",border: `1px solid black`,}}>{item.assignedCount}/{item.totalTeamCount}</b></td>
                  <td>
                    <Button onMouseMove={(e)=> { e.target.style.backgroundColor="lightgray";e.target.style.color="black"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor="lightseagreen";e.target.style.color="white"; }}
                      onClick={() => userDetailstoAssignClient(item.requirement._id)}
                      style={{padding: "5px",borderRadius: "8px",backgroundColor: "lightseagreen",color: "white",border: "1.5px solid black",fontWeight:"bold"}}>
                   Assign
                    </Button>
                  </td>
                
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No requirements found</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showprofiles && view !== 'profiles'}
        onHide={() => setShowprofiles(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          <h3>
          <img
            style={{ width: "30px", margin: "10px" }}
            src='/Images/icon.png'
            alt="icon"
          />
          <b style={{ fontFamily: "monospace" }}>Profiles</b>
        </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

        <CardGroup>
  <Link onClick={()=> setShowTodayData(true)}  style={{ textDecoration: "none", color: "black" }} >
    <Card style={{ margin: "20px", width: "200px" }} className="text-center">
      <Card.Body>
        <Card.Title style={{ fontFamily: "initial" }}>
          <b>Today Profiles</b>
        </Card.Title>
      </Card.Body>
      <Card.Footer>
        <Button variant="success"  style={{borderRadius:"50px"}}>
          <h6><b>{todayCount}</b></h6>
        </Button>
      </Card.Footer>
    </Card>
  </Link>
  <Link onClick={()=> setShowTodayData(true)} style={{ textDecoration: "none", color: "black" }} >
  {/* <Link onClick={()=> setShowRequirmentCount(true)} style={{ textDecoration: "none", color: "black" }} > */}
    <Card style={{ margin: "20px", width: "200px" }} className="text-center">
      <Card.Body>
        <Card.Title style={{ fontFamily: "initial" }}>  
          <b>Active Profiles</b>
        </Card.Title>
      </Card.Body>
      <Card.Footer>
        <Button variant="warning" style={{borderRadius:"20px"}}>
         <h6><b>{totalCount}</b></h6>
        </Button>
      </Card.Footer>
    </Card>
  </Link>

  <Link onClick={() => setLgShow(true)}  style={{ textDecoration: "none", color: "black" }}>
    <Card style={{ margin: "20px", width: "200px" }} className="text-center">
      <Card.Body>
        <Card.Title style={{ fontFamily: "initial" }}>
          <b>Team Profiles</b>
        </Card.Title>
      </Card.Body>
      <Card.Footer>
        <Button variant="secondary" >
          <img src="./Images/team.svg" alt="Assign Requirement" />
        </Button>
      </Card.Footer>
    </Card>
  </Link>

  <Link to="/team/clients" style={{ textDecoration: "none", color: "black" }}>
    <Card style={{ margin: "20px", width: "200px" }} className="text-center">
      <Card.Body>
        <Card.Title style={{ fontFamily: "initial" }}>
          <b>Client Profiles</b>
        </Card.Title>
      </Card.Body>
      <Card.Footer>
        <Button variant="primary">
          <img src="./Images/client.svg" alt="Profiles" />
        </Button>
      </Card.Footer>
    </Card>
  </Link>
</CardGroup>
</div>

        </Modal.Body>
      </Modal>

      <Modal
      style={{backgroundColor:"lightgray"}}
        size="lg"
        show={showReq}
        onHide={() => setShowReq(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          <h3>
          <img
            style={{ width: "30px", margin: "10px" }}
            src='/Images/icon.png'
            alt="icon"
          />
          <b style={{ fontFamily: "monospace" }}>Requirement Details</b>
        </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {showReq && viewReq.length > 0 ? (
  <Table   bordered hover responsive>
    <tbody>
      {viewReq.map((item, index) => (
        <React.Fragment key={index}>
           <tr>
            <th>Reg ID</th>
            <td>{item.regId}</td>
          </tr>
          <tr>
            <th>Client</th>
            <td>{item.client}</td>
          </tr>
          {/* <tr>
            <th>Client ID</th>
            <td>{item.clientId}</td>
          </tr> */}
          <tr>
            <th>Duration</th>
            <td>{item.duration}</td>
          </tr>
          <tr>
            <th>Location</th>
            <td>{item.location}</td>
          </tr>
          <tr>
            <th>Qualification</th>
            <td>{item.qualification}</td>
          </tr>
          <tr>
            <th>Years of Experience</th>
            <td>{item.yearsExperience}</td>
          </tr>
          <tr>
            <th>Relevant Experience</th>
            <td>{item.relevantExperience}</td>
          </tr>
          <tr>
            <th>Requirement Type</th>
            <td>
              <RequirementTypeSelect
                requirementId={item._id}
                value={item.requirementtype}
                onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(item._id, nextType, updatedRequirement)}
              />
            </td>
          </tr>
          <tr>
            <th>Priority</th>
            <td><PriorityBadge priority={item.priority} /></td>
          </tr>
          <tr>
            <th>Skill</th>
            <td>{item.skill}</td>
          </tr>
          <tr>
            <th>Role</th>
            <td>{item.role}</td>
          </tr>
          <tr>
            <th>Source CTC</th>
            <td>{item.sourceCtc}</td>
          </tr>
          <tr>
            <th>ECTC</th>
            <td>{item.ectc || '—'}</td>
          </tr>
          <tr>
            <th>Start Date</th>
            <td>{new Date(item.startDate).toLocaleDateString()}</td>
          </tr>
          <tr>
            <th>Type of Contract</th>
            <td>{item.typeOfContract}</td>
          </tr>
          <tr>
            <th>Update</th>
            <td>{item.update}</td>
          </tr>
          {/* <tr>
            <th>Uploaded By</th>
            <td>{item.uploadedBy}</td>
          </tr> */}
          <tr>
            <th>Uploaded Date</th>
            <td>{new Date(item.uploadedDate).toLocaleDateString()}</td>
          </tr>
          <tr>
            <th>JD PDF</th>
            <td>
              <RequirementJdActions requirement={item} />
            </td>
          </tr>
          
          <tr style={{textAlign:"center"}}>
          <th colSpan={2}><h4>
          <img
            style={{ width: "30px", margin: "10px" }}
            src='/Images/icon.png'
            alt="icon"
          />
          <b style={{ fontFamily: "monospace" }}>Assessment</b>
        </h4></th>
          </tr>
          <tr>
            <td>
              {item.assessments.length > 0 ? (
                <Table responsive bordered >
                  <thead >
                    <tr>
                      <th>Assessment</th>
                      <th>Expected Rating</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {item.assessments.map((assessment, assessIndex) => (
                      <tr key={assessIndex}>
                        <td>{assessment.assessment || 'N/A'}</td>
                        <td>{assessment.yoe || 'N/A'}</td>
                        
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                'No assessments'
              )}
            </td>
          </tr>
          {/* <tr>
            <th>Claimed By</th>
            <td>{item.claimedBy.length > 0 ? JSON.stringify(item.claimedBy) : 'No claims'}</td>
          </tr> */}
          <tr>
            <td colSpan="2"><hr /></td> {/* Separator for clarity */}
          </tr>
        </React.Fragment>
      ))}
    </tbody>
  </Table>
) : (
  <p>No requirements to display.</p>
)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReq(false)}>
            Close
          </Button>
          {viewReq[0] && canEditRequirement(viewReq[0], userId) && (
            <Button variant="primary" onClick={() => setShowEditReq(true)}>
              Edit Requirement
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <RequirementEditModal
        show={showEditReq}
        onHide={() => setShowEditReq(false)}
        requirement={viewReq[0]}
        onSaved={handleRequirementEdited}
      />

      <Modal
      style={{backgroundColor:"lightgray",opacity:"98%"}}
        size="lg"
        show={showAssign}
        onHide={() => setShowAssign(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
          {Array.isArray(assignReqdetails) && assignReqdetails.length > 0 ? (
  assignReqdetails.map((item, index) => (
    <h3 key={index}>
      <img
        style={{ width: "30px", margin: "10px" }}
        src='/Images/icon.png'
        alt="icon"
      />
      <b style={{ fontFamily: "monospace" }}> 
        Assign {item.client || 'No client'} 
      </b>
    </h3>
  ))
) : (
  <p>No data available</p>
)}


          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div>
        {assignReqdetails[0] && !canAssignRequirement(assignReqdetails[0]) && (
          <div className="alert alert-warning mb-3">
            {getAssignDisabledMessage(assignReqdetails[0])}
          </div>
        )}
        <center>
  {/* Displaying Team Information */}
  {userData && userData.length > 0 ? ( // Ensure userData is not null or undefined
    <div>
      <Table hover responsive style={{textAlign: "center"}}>
        <thead>
          <tr>
            <th>Employee Code</th>
            <th>Employee Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {userData.map((team, index) => (
            <tr key={index}>
              <td>
                <Link style={{textDecoration: "none"}} onClick={() => readUserDatafun(team._id)}>
                  <b>{team.EmpCode}</b>
                </Link>
              </td>
              <td><b style={{fontFamily:"monospace"}}>{team.EmployeeName}</b></td>
              {/* <td>{team.Email}</td>  */}
              {/* Replace with actual fields */}
              <td>
                <Button
                  disabled={assignReqdetails[0] && !canAssignRequirement(assignReqdetails[0])}
                  onClick={() => assignReqToUser(team._id)}
                  onMouseMove={(e)=>{e.target.style.backgroundColor = "lightgreen"}}
                  onMouseLeave={(e)=>{e.target.style.backgroundColor = "lightsteelblue"}}
                  style={{backgroundColor: "lightsteelblue", color: "black", border: "0px",fontWeight:"bold"}}
                >
                  Assign
                </Button>
              </td>
             
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  ) : (
    <div>No team data available.</div> // Display a message if there is no data
  )}
</center>
 <hr></hr>
 <center>
  {/* Displaying Assigned Team Information */}
  <h4>
    <img
      style={{ width: "30px", margin: "10px" }}
      src='/Images/icon.png'
      alt="icon"
    />
    <b style={{ fontFamily: "monospace" }}>Assigned Users</b>
  </h4>

  {assignedUsersData && assignedUsersData.length > 0 ? (
    <div>
      <Table hover responsive style={{ textAlign: "center" }}>
        <thead>
          <tr>
            <th>Sno</th>
            <th>Employee Code</th>
            <th>Employee Name</th>
            <th>User Type</th>
            <th>Upload Status</th>
            <th>Action</th>
            <th>Unassign</th>
          </tr>
        </thead>
        <tbody>
          {assignedUsersData.map((team, index) => {
            const {
              badgeActive,
              buttonAction,
              canToggle,
              toggleManualActive,
            } = getUploadDisplayState(team);
            return (
            <tr key={team._id || index}>
              <td>{index + 1}</td>
              <td>
                <Link style={{ textDecoration: "none" }} onClick={() => readUserDatafun(team._id)}>
                  <b>{team.EmpCode}</b>
                </Link>
              </td>
              <td><b style={{fontFamily:"monospace"}}>{team.EmployeeName}</b></td>
              <td>{team.UserType || 'User'}</td>
              <td>
                <UploadStatusBadge isManuallyActive={badgeActive} />
              </td>
              <td>
                <UploadActionButton
                  isManuallyActive={badgeActive}
                  buttonAction={buttonAction}
                  disabled={!canToggle}
                  onClick={() => {
                    if (!canToggle) return;
                    toggleAssignedUserUploadStatus(team._id, toggleManualActive);
                  }}
                />
              </td>
              <td>
                <Button onClick={()=> unassignReqFromUser(team._id)} onMouseMove={(e)=>{e.target.style.backgroundColor = "lightsteelblue"}} onMouseLeave={(e)=>{e.target.style.backgroundColor = "indianred"}}  style={{backgroundColor: "indianred", color: "white", border: "0px",fontWeight:"bold"}}>
                  Un Assign
                </Button>
              </td>
            </tr>
          )})}
        </tbody>
      </Table>
    </div>
  ) : (
    <div>
      <h5 style={{ fontFamily: "monospace", color: "gray" }}>No Assigned Users...!</h5> {/* Display this when no users are assigned */}
    </div>
  )}
</center>

      <center>
      <Row>
    <Col>
  {showUserData && showUserData.userDetails && (
    <Modal  style={{backgroundColor:"lightgray",opacity:"95%"}}
    show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <strong className="me-auto">
          <b style={{ fontFamily: "monospace", margin: "5px" }}>
            Employee Name:
          </b>
          {showUserData.userDetails.EmployeeName || "N/A"}
        </strong>
        <small>
          <b style={{ fontFamily: "monospace", margin: "5px" }}>Emp Code:</b>
          {showUserData.userDetails.EmpCode || "N/A"}
        </small>
      </Modal.Header>
      <Modal.Body>
        <center>
          {showUserData.userDetails.ProfilePic ? (
            <img
              style={{ width: "200px" }}
              src={`${API_BASE_URL}/${showUserData.userDetails.ProfilePic}`}
              alt="Profile"
            />
          ) : (
            <p>No Profile Picture Available</p>
          )}
        </center>
        <hr />
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>Email:</b>
          {showUserData.userDetails.Email || "N/A"}
        </p>
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>
            User Type:
          </b>
          {showUserData.userDetails.UserType || "N/A"}
        </p>
        <p>
          <b style={{ fontFamily: "monospace", margin: "20px" }}>Status:</b>
          {showUserData.userDetails.Status || "N/A"}
        </p>
        <hr />
        <center>
          <h5>
            <img
              style={{ width: "30px", margin: "10px" }}
              src="/Images/icon.png"
              alt="icon"
            ></img>
            <b style={{ fontFamily: "monospace" }}>Team Details</b>
          </h5>
        </center>
        <Table
        style={{textAlign:"center"}}
          disabled={showUserData.userDetails.UserType !== "TeamLead"}
          responsive
        >
          <thead>
            <tr>
              <th>Emp Code</th>
              <th>Employee Name</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {showUserData.teamDetails && showUserData.teamDetails.length > 0 ? (
              showUserData.teamDetails.map((teamMember) => (
                <tr key={teamMember._id}>
                  <td>{teamMember.EmpCode || "N/A"}</td>
                  <td>{teamMember.EmployeeName || "N/A"}</td>
                  <td>{teamMember.Email || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center",color:"indianRed" }}>
                  No Team Member...!
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )}
</Col>
</Row>
      </center>

    </div>
          
        </Modal.Body>
      </Modal>

      <Modal
                size="lg"
                show={showTodayData && view !== 'profiles'}
                onHide={() => setShowTodayData(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                style={{ backgroundColor: "lightgray", opacity: "98%" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        <h3>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Source Profile Submissions</b>
                        </h3>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h5 style={{ textAlign: "center" }}>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Submissions by Recruiter</b>
                        </h5>
                        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                            <input
                                type="search"
                                placeholder="Search by Name, Email or Code"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                style={{ marginBottom: "20px", width: "100%", maxWidth: "300px", padding: "10px", border: "2px solid gray", borderRadius: "20px" }}
                            />
                        </div>

                        {filteredRecruiters.length > 0 ? (
                            <div style={{ overflowX: 'auto' }}>
                                <Table style={{textAlign:"center"}}  bordered hover responsive>
                                    <thead style={{ textAlign: 'center' }}>
                                        <tr>
                                            <th>Emp Code</th>
                                            <th>Recruiter Name</th>
                                            {/* <th>Email</th> */}
                                            <th>Uploaded Today</th>
                                            <th>Total Uploaded</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: 'center' }}>
                                        {filteredRecruiters.map(recruiter => (
                                            <tr key={recruiter.recruiterId}>
                                                <td>{recruiter.recruiterCode}</td>
                                                <td>{recruiter.recruiterName}</td>
                                                {/* <td>{recruiter.recruiterEmail}</td> */}
                                                <td>
                                                    <Link 
                                                        onClick={() => {

                                                            setshowtodayCandidates(true);
                                                            // Store current recruiter data for use in the next modal
                                                            setCurrentRecruiter(recruiter);
                                                        }} 
                                                        style={{ textDecoration: "none" }}
                                                    >
                                                        <b>{recruiter.todaysCandidates}</b>
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link 
                                                        onClick={() => {
                                                          RequirmentCandidates(recruiter.recruiterId);
                                                            // setshowtotalCandidates(true);
                                                            // Store current recruiter data for use in the next modal
                                                            setCurrentRecruiter(recruiter);
                                                        }} 
                                                        style={{ textDecoration: "none" }}
                                                    >
                                                        <b>{recruiter.totalCandidates}</b>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <p>No recruiter data available.</p>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                size="fullscreen"
                show={showtodayCandidates}
                onHide={() => setshowtodayCandidates(false)}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        <h5 style={{ textAlign: "center" }}>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Uploaded Today</b>
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table style={{textAlign:"center"}}  bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Skills</th>
                                <th>Total YOE</th>
                                 <th>LWD</th>
                                <th>ECTC</th>
                                <th>Uploaded On</th>
                            </tr>
                        </thead>
                        <tbody>
                        {currentRecruiter && currentRecruiter.todaysCandidatesData && currentRecruiter.todaysCandidatesData.length > 0 ? (
    currentRecruiter.todaysCandidatesData.map((candidate, index) => (
        <tr key={index}>
            <td>{candidate.firstName}{candidate.lastName}</td>
            <td>{candidate.candidateSkills}</td>
                    <td>{candidate.totalYoe}</td>
                    <td>{formatLwdDisplay(candidate.lwd)}</td>
                    <td>{candidate.ectc}</td>
            <td>{new Date(candidate.uploadedOn).toLocaleDateString()}</td>
            <td> <Link onClick={()=> CandidateData(candidate._id)}><Image  style={{backgroundColor:"lightblue",margin:"5px",padding:"10px",borderRadius:"10px"}} src='./Images/view.svg'></Image></Link> </td>

           <td>
          <Link > <Image  style={{backgroundColor:"IndianRed",margin:"5px",padding:"10px",borderRadius:"10px"}} src='./Images/trash.svg'></Image></Link>
           </td>
        </tr>
    ))
) : (
    <tr>
        <td colSpan="2">No source profiles uploaded </td>
    </tr>
)}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>

            <Modal
      size="fullscreen"
      show={showtotalCandidates}
      onHide={() => setshowtotalCandidates(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      onShow={fetchCandidates}  // Fetch candidates when modal is shown
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          <h5 style={{ textAlign: "center" }}>
            <img
              style={{ width: "30px", margin: "10px" }}
              src="/Images/icon.png"
              alt="icon"
            />
            <b style={{ fontFamily: "monospace" }}>Total Source Profiles</b>
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        {candidates.length > 0 ? (
          <Table style={{textAlign:"center"}}  bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Skills</th>
                <th>Total YOE</th>
                <th>LWD</th>
                <th>ECTC</th>
                <th>Uploaded Date</th>
              </tr>
            </thead>
            <tbody>
              {candidates.map((candidate, index) => (
                <tr key={index}>
                  <td>{candidate.firstName}{candidate.lastName}</td>
                  <td>{candidate.candidateSkills}</td>
                  <td>{candidate.totalYoe}</td>
                  <td>{formatLwdDisplay(candidate.lwd)}</td>
                  <td>{candidate.ectc}</td>
                  <td>{new Date(candidate.uploadedOn).toLocaleDateString()}</td>
                  <td> <Link onClick={()=> CandidateData(candidate._id)}><Image  style={{backgroundColor:"lightblue",margin:"5px",padding:"10px",borderRadius:"10px"}} src='./Images/view.svg'></Image></Link> </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : !loading && <p>No source profiles found.</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setshowtotalCandidates(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>

            <Modal
            style={{backgroundColor:"lightgray",opacity:'98%'}}
        size="lg"
        show={showRequirmentCount}
        onHide={() => setShowRequirmentCount(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
          <h5 style={{ textAlign: "center" }}>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Total Uploaded</b>
                        </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <h5 style={{ textAlign: "center" }}>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Requirements List</b>
                        </h5>
      {requirementsData.length === 0 ? (
        <p>No requirements found.</p>
      ) : (
        <Table style={{textAlign:"center"}}  bordered hover responsive>
          <thead>
            <tr>
              <th>Requirement ID</th>
              <th>Client</th>
              <th>Requirement Type</th>
              <th>Start Date</th>
              <th>Type Of Contract</th>
              <th>Source Profile Count</th>
            </tr>
          </thead>
          <tbody>
            {requirementsData.map((req) => (
              <tr key={req._id} style={{textAlign:"center"}}>
                <td>{req.regId}</td>
                <td>{req.client || 'No Title Available'}</td>
                <td>
                  <RequirementTypeSelect
                    requirementId={req._id}
                    value={req.requirementtype}
                    onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(req._id, nextType, updatedRequirement)}
                  />
                </td>
                <td>{new Date(req.startDate).toLocaleDateString()}</td>
                <td>{req.typeOfContract}</td>
                <td><Link onClick={()=> fetchCandidates(req._id)} style={{textDecoration:"none"}}><b>{req.candidateCount || 0}</b></Link></td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
        </Modal.Body>
      </Modal>
      
    {/* Your Uploads Modal */}
    <Modal
      show={showUserModal}
      onHide={handleCloseUserModal}
      onShow={() => {
        if (userUploadsModalMeta.requirementId) {
          refreshUserUploadsCandidates(userUploadsModalMeta.requirementId);
        }
      }}
      size="xl"
      centered
      className="hr-modal"
    >
    <Modal.Header closeButton>
      <Modal.Title> <h3 style={{ textAlign: "center" }}>
                            <img
                                style={{ width: "30px", margin: "10px" }}
                                src='/Images/icon.png'
                                alt="icon"
                            />
                            <b style={{ fontFamily: "monospace" }}>Your Uploads</b>
                        </h3></Modal.Title>
    </Modal.Header>

    <Modal.Body>
  {/* Search Inputs for User Candidates */}
  <Row className="justify-content-center" style={{ gap: "10px", marginBottom: "20px" }}>
  {/* Search by Name */}
  <Col xs={12} sm={6} md={3}>
    <FormControl
      type="search"
      placeholder="Search by Name"
      value={name}
      onChange={(e) => setName(e.target.value)}
      style={{ width: "100%", border: "1px solid black", borderRadius: "15px" }}
    />
  </Col>

  {/* Search by Role */}
  <Col xs={12} sm={6} md={3}>
    <FormControl
      type="search"
      placeholder="Search by Role"
      value={role}
      onChange={(e) => setRole(e.target.value)}
      style={{ width: "100%", border: "1px solid black", borderRadius: "15px" }}
    />
  </Col>

  {/* Status Select */}
  <Col xs={12} sm={6} md={3}>
    <FormControl
      as="select"
      value={status}
      onChange={(e) => setStatus(e.target.value)}
      style={{ width: "100%", border: "1px solid black", borderRadius: "15px" }}
    >
      <option value="">All Statuses</option>
      {statusSearchOptions.map((option, idx) => (
        <option key={idx} value={option}>
          {option}
        </option>
      ))}
    </FormControl>
  </Col>

  {/* Saved Status Select */}
  <Col xs={12} sm={6} md={3}>
    <FormControl
      as="select"
      value={savedStatus}
      onChange={(e) => setSavedStatus(e.target.value)}
      style={{ width: "100%", border: "1px solid black", borderRadius: "15px" }}
    >
      <option value="">All Types</option>
      <option value="Saved">Saved</option>
      <option value="Uploaded">Uploaded</option>
    </FormControl>
  </Col>

  {/* Search Button */}
  <Col xs={12} className="text-center mt-2">
    <Button variant="primary" onClick={handleUserCandidatesSearch} style={{ width: "100%", maxWidth: "300px" }}>
      Search
    </Button>
  </Col>
</Row> <hr></hr>


  {/* User Candidate Table */}
  {displayedCandidates && displayedCandidates.length > 0 ? (
    <Table  bordered hover responsive style={{ textAlign: "center" }}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Role</th>
          <th>Total YOE</th>
          <th>LWD</th>
          <th>ECTC</th>
          <th>Status</th>
          <th>Uploaded Date</th>
          <th colSpan={4}>Action</th>
        </tr>
      </thead>
      <tbody>
        {displayedCandidates.map((candidate) => {
          const recentStatus = getRecentCandidateStatus(candidate);

          return (
            <tr key={candidate._id}>
              <td>{candidate.firstName} {candidate.lastName}</td>
              <td>{candidate.role}</td>
              <td>{candidate.totalYoe}</td>
              <td>{formatLwdDisplay(candidate.lwd)}</td>
              <td>{candidate.ectc}</td>
              <td><StatusBadge status={recentStatus} useStoredLabel /></td>
              <td>{new Date(candidate.uploadedOn).toLocaleDateString()}</td>
              <td>
                <Link onClick={() => CandidateData(candidate._id)}>
                  <Image onMouseMove={(e)=> { e.target.style.backgroundColor="gray"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor="lightblue"; }}
                    style={{ backgroundColor: "lightblue", margin: "5px", padding: "10px", borderRadius: "10px" }} 
                    src='./Images/view.svg' 
                  />
                </Link>
              </td>
              <td>
                <Link onClick={() => deleteCandidate(candidate._id)} style={{ pointerEvents: recentStatus === "No Action Taken" ? "auto" : "none" }}>
                  <Image onMouseMove={(e)=> { e.target.style.backgroundColor="gray"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor= recentStatus === "No Action Taken" ? "indianred" : ""; }}
                    style={{ backgroundColor: recentStatus === "No Action Taken" ? "indianred" : "lightgray", margin: "5px", padding: "10px", borderRadius: "10px", opacity: recentStatus === "No Action Taken" ? 1 : 0.5 }} 
                    src='./Images/trash.svg' 
                  />
                </Link>
              </td>
              <td>
                <Link onClick={() => updateCandidate(candidate._id)} style={{ pointerEvents: recentStatus === "No Action Taken" ? "auto" : "none" }}>
                <Image onMouseMove={(e)=> { e.target.style.backgroundColor="gray"; }} onMouseLeave={(e)=> { e.target.style.backgroundColor= recentStatus === "No Action Taken" ? "lightgreen" : ""; }}
                    style={{ backgroundColor: recentStatus === "No Action Taken" ? "lightgreen" : "lightgray", margin: "5px", padding: "10px", borderRadius: "10px", opacity: recentStatus === "No Action Taken" ? 1 : 0.5 }} 
                    src='/Images/edit.svg' 
                  />
                </Link>
              </td>
              <td>
                {candidate.savedStatus === 'Saved' && (
                  <Button 
                    onClick={() => updateCandidate(candidate._id)} 
                    style={{ fontWeight: "bold", backgroundColor: "green", border: "0px", padding: "5px", borderRadius: "20px" }} 
                    onMouseMove={(e) => { e.target.style.backgroundColor = "gray"; e.target.style.padding = "10px"; }} 
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "green"; e.target.style.padding = "5px"; }}
                  >
                    Upload
                  </Button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  ) : (
    <p>No user candidates match your search criteria.</p>
  )}
</Modal.Body>


    <Modal.Footer>
      <Button variant="secondary" onClick={handleCloseUserModal}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>

  {/* Candidate Modal */}
  <Modal
    show={lagShow}
    onHide={() => setLagShow(false)}
    size="xl"
    centered
    className="hr-modal"
    backdrop="static"
  >
    <Modal.Header closeButton className="hr-modal-header">
      <Modal.Title>
        <div className="hr-modal-title">
          <img src="/Images/icon.png" alt="" className="hr-modal-icon" />
          <div>
            <h5 className="mb-0">Source Profile Details</h5>
            {candidateDetails && candidateDetails.firstName ? (
              <small className="text-muted">
                {`${candidateDetails.firstName} ${candidateDetails.lastName || ''}`.trim()}
              </small>
            ) : null}
          </div>
        </div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="hr-modal-body">
    {candidateDetails && (
    <div className="table-responsive">
    <Table bordered hover className="table-sm hr-data-table mb-0">
        <tbody>
        <tr>
            <td>
              <Image
                src={buildApiAssetUrl(candidateDetails.candidateImage)}
                style={{ width: "100px", borderRadius: "100px" }}
                alt="Candidate Image"
              ></Image>
            </td>
            <td>
  <StatusUpdatePanel
    selectedStatus={selectedStatus}
    onStatusChange={handleStatusChange}
    statusRemark={statusRemark}
    onRemarkChange={(event) => setStatusRemark(event.target.value)}
    statusInterviewDate={statusInterviewDate}
    onInterviewDateChange={(event) => setStatusInterviewDate(event.target.value)}
    onSubmit={() => postStatus(candidateId)}
  />
  <hr />

  <StatusHistorySection
    candidate={candidateDetails}
    candidateId={candidateId}
    onRemarkAdded={handleStatusRemarkAdded}
  />
</td>
          </tr>

            <tr>
                <td><b>Source Profile Name</b></td>
                <td>{candidateDetails.firstName} {candidateDetails.lastName}</td>
            </tr>
            <tr>
                <td><b>Email:</b></td>
                <td>{candidateDetails.email}</td>
            </tr>
            <tr>
                <td><b>Dob:</b></td>
                <td>{formatDisplayDate(candidateDetails.dob)}</td>
            </tr>
            <tr>
                <td><b>Mobile Number:</b></td>
                <td>{candidateDetails.mobileNumber}</td>
            </tr>
            {/* <tr>
                <td><b>Client</b></td>
                <td>{candidateDetails.client}</td>
            </tr> */}
            <tr>
                <td><b>Skills:</b></td>
                <td>{candidateDetails.candidateSkills}</td>
            </tr>
            <tr>
                <td><b>Ctc:</b></td>
                <td>{candidateDetails.ctc}</td>
            </tr>
            <tr>
                <td><b>Ectc:</b></td>
                <td>{candidateDetails.ectc}</td>
            </tr>
            <tr>
                <td><b>Educational Qualification:</b></td>
                <td>{candidateDetails.educationalQualification}</td>
            </tr>
            <tr>
                <td><b>Total YOE:</b></td>
                <td>{candidateDetails.totalYoe}</td>
            </tr>
            <tr>
                <td><b>Relevant YOE:</b></td>
                <td>{candidateDetails.relevantYoe}</td>
            </tr>
            <tr>
              <td><strong>Current Location:</strong></td>
              <td>{candidateDetails.currentLocation}</td>
           </tr>
            <tr>
                <td><b>Preferred Location:</b></td>
                <td>{candidateDetails.prefLocation}</td>
            </tr>
            <tr>
                <td><b>Current Org:</b></td>
                <td>{candidateDetails.currentOrg}</td>
            </tr>
            <tr>
                <td><b>Role:</b></td>
                <td>{candidateDetails.role}</td>
            </tr>
            <tr>
                <td><b>Resignation Served:</b></td>
                <td>{candidateDetails.resignationServed}</td>
            </tr>
            <tr>
                <td><b>LWD:</b></td>
                <td>{formatLwdDisplay(candidateDetails.lwd)}</td>
            </tr>
            {/* <tr>
                <td><b>Status:</b></td>
                <td>{candidateDetails.Status}</td>
            </tr> */}
            <tr>
                <td><b>Offer In Hand:</b></td>
                <td>{candidateDetails.offerInHand}</td>
            </tr>
            <tr>
                <td><b>Interview Date:</b></td>
                <td>{formatInterviewDate(candidateDetails.interviewDate)}</td>
            </tr>
            <tr>
                <td><b>About Source Profile:</b></td>
                <td>{candidateDetails.details}</td>
            </tr>
            <tr>
                <td><b>Recruiter Feedback:</b></td>
                <td>{candidateDetails.feedback}</td>
            </tr>
            <tr>
                <td><b>Remark:</b></td>
                <td>{candidateDetails.remark}</td>
            </tr>
            {/* <tr>
                <td><b>Shared With Client:</b></td>
                <td>{candidateDetails.sharedWithClient}</td>
            </tr> */}
            <SourceProfileDocumentFields
              candidateId={candidateId}
              updatedResume={candidateDetails.updatedResume}
              ornnovaProfile={candidateDetails.ornnovaProfile}
              canUpload
              onDocumentsUpdated={(updated) => {
                if (!updated) return;
                setCandidateDetails((prev) => (prev ? { ...prev, ...updated } : prev));
              }}
            />
            <tr>
            <td colSpan="2"><center><label> <h5> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >Assessment</b></h5></label></center></td>

            </tr>
            {
                candidateDetails.assessments && Array.isArray(candidateDetails.assessments) && candidateDetails.assessments.length > 0 ? (
                    candidateDetails.assessments.map((item, index) => (
                        <React.Fragment key={index}>
                            <tr>
                                <td><b>Assessment:</b></td>
                                <td>{item.assessment}</td>
                            </tr>
                            <tr>
                                <td><b>Expected Rating:</b></td>
                                <td>{item.yoe}</td>
                            </tr>
                            <tr>
                                <td><b>Candidate Rating:</b></td>
                                <td>{item.score}</td>
                            </tr> <hr></hr>
                        </React.Fragment>
                    ))
                ) : (
                    <tr>
                        <td colSpan={2}>No assessments available.</td>
                    </tr>
                )
            }
        </tbody>
    </Table>
    </div>
    )}
    </Modal.Body>
    <Modal.Footer className="hr-modal-footer">
      <Button variant="secondary" onClick={() => setLagShow(false)}>
        Close
      </Button>
      <Button
        variant="primary"
        className="hr-btn-primary"
        disabled={!canEditFullSourceProfileDetails(candidateDetails)}
        title={
          !canEditFullSourceProfileDetails(candidateDetails)
            ? 'Profile fields can be edited only when status is No Action Taken. Resume and Ornnova profile can still be updated below.'
            : ''
        }
        onClick={() => {
          if (candidateId) {
            updateCandidate(candidateId);
            setLagShow(false);
          }
        }}
      >
        Edit
      </Button>
    </Modal.Footer>
  </Modal>

               <Modal
      style={{ backgroundColor: "lightgray", opacity: "98%" }}
      show={updateshow}
      size="lg"
      onHide={handleUpdateClose}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          <h5>
            <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img>
            <b style={{ fontFamily: "monospace" }}>Update Source Profile Information</b>
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form style={{backgroundColor:"lightsteelblue",borderRadius:"20px"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label><strong>Candidate Image:</strong></label>
                        <div>
                            <img
                                src={`${API_BASE_URL}/${updateCandidateDetails.candidateImage}`}
                                style={{ width: "100px", borderRadius: "100px" }}
                                alt=""
                            />
                        </div>
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>First Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.firstName}
                            onChange={(e) => handleInputChange('firstName', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lastName}
                            onChange={(e) => handleInputChange('lastName', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Email:</strong></label>
                        <input
                            type="email"
                            className="form-control"
                            value={updateCandidateDetails.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Mobile Number:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.mobileNumber}
                            onChange={(e) => handleInputChange('mobileNumber', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Date of Birth:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDateInputValue(updateCandidateDetails.dob)}
                            onChange={(e) => handleInputChange('dob', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>CTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ctc}
                            onChange={(e) => handleInputChange('ctc', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>ECTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ectc}
                            onChange={(e) => handleInputChange('ectc', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Total YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.totalYoe}
                            onChange={(e) => handleInputChange('totalYoe', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Relevant YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.relevantYoe}
                            onChange={(e) => handleInputChange('relevantYoe', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>LWD:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lwd ?? ''}
                            onChange={(e) => handleInputChange('lwd', e.target.value)}
                            placeholder="LWD"
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Current Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentLocation}
                            onChange={(e) => handleInputChange('currentLocation', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Preferred Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.prefLocation}
                            onChange={(e) => handleInputChange('prefLocation', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Resignation Served:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.resignationServed}
                            onChange={(e) => handleInputChange('resignationServed', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Current Organization:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentOrg}
                            onChange={(e) => handleInputChange('currentOrg', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Candidate Skills:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.candidateSkills}
                            onChange={(e) => handleInputChange('candidateSkills', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Role:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.role}
                            onChange={(e) => handleInputChange('role', e.target.value)}
                        />
                    </div>
                   
                </div>
                {/* <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Internal Screening:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.internalScreening}
                            onChange={(e) => handleInputChange('internalScreening', e.target.value)}
                        >
                            <option value="Selected">Selected</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Shared With Client:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.sharedWithClient}
                            onChange={(e) => handleInputChange('sharedWithClient', e.target.value)}
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                   
                </div> */}
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Recruiter Feedback:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.feedback}
                            onChange={(e) => handleInputChange('feedback', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>About Candidate:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.details}
                            onChange={(e) => handleInputChange('details', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label><strong>Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('interviewDate', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Interview Time:</strong></label>
                        <input
                            type="time"
                            className="form-control"
                            value={updateCandidateDetails.interviewTime || ''}
                            onChange={(e) => handleInputChange('interviewTime', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Educational Qualification:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.educationalQualification}
                            onChange={(e) => handleInputChange('educationalQualification', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Offer In Hand:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.offerInHand}
                            onChange={(e) => handleInputChange('offerInHand', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('lastInterviewDate', e.target.value)}
                        />
                    </div>
                </div> <hr></hr>
                <div className="row">
            <div className="col-md-12 form-group">
                <h3>
                    <img style={{width: "30px", margin: "10px"}} src='/Images/icon.png' alt="icon" />
                    <b style={{fontFamily: "monospace"}}>Assessment Details</b>
                </h3>
                {updateCandidateDetails.assessments.map((assessment, index) => (
                    <div key={index} className="form-group">
                        <label><strong>Assessment {index + 1}:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.assessment}
                        />
                        <label><strong>Expected Rating:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.yoe}
                        />
                        <label><strong>Candidate Rating:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={assessment.score}
                            onChange={(e) => handleAssessmentChange(index, 'score', e.target.value)}
                        />
                        <hr />
                    </div>
                ))}
            </div>
        </div>
            </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
      {updateCandidateDetails.savedStatus === "Saved" && (
                    <Button style={{borderRadius:"20px",backgroundColor:"mediumseagreen",color:"white",border:"1.5px solid black",fontWeight:"bold"}}
                        type="button"
                        className="btn btn-secondary ml-2"
                        onMouseMove={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "black";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "mediumseagreen";e.target.style.color = "white";e.target.style.padding = "7px"; }}
                        onClick={uploadChanges}
                        // onClick={handleUploadStatus}
                    >
                        Upload
                    </Button>
                )}
        <Button                         onMouseMove={(e)=> { e.target.style.backgroundColor = "green";e.target.style.color = "white";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "green";e.target.style.padding = "7px"; }}
 style={{borderRadius:"20px",backgroundColor:"lightgray",color:"green",border:"1.5px solid black",fontWeight:"bold"}} onClick={saveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>


 </PageShell>
  );
}

export default TLHome;
